// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.10.0_webpack@5.91.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.10.0_webpack@5.91.0/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.10.0_webpack@5.91.0/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg width=%2716%27 height=%2712%27 viewBox=%270 0 16 12%27 fill=%27none%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath d=%27M2 6L6 10L14 2%27 stroke=%27%23161819%27 stroke-width=%272%27 stroke-linecap=%27square%27/%3E%3C/svg%3E%0A", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
! tailwindcss v3.4.1 | MIT License | https://tailwindcss.com
*//*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

.ni-tailwind-namespace *,
.ni-tailwind-namespace ::before,
.ni-tailwind-namespace ::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: currentColor; /* 2 */
}

.ni-tailwind-namespace ::before,
.ni-tailwind-namespace ::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

.__UNUSED__html,
.ni-tailwind-namespace :host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */
  -moz-tab-size: 4; /* 3 */
  -o-tab-size: 4;
     tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

.__UNUSED__body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

.ni-tailwind-namespace hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

.ni-tailwind-namespace abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

.ni-tailwind-namespace h1,
.ni-tailwind-namespace h2,
.ni-tailwind-namespace h3,
.ni-tailwind-namespace h4,
.ni-tailwind-namespace h5,
.ni-tailwind-namespace h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

.ni-tailwind-namespace a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

.ni-tailwind-namespace b,
.ni-tailwind-namespace strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

.ni-tailwind-namespace code,
.ni-tailwind-namespace kbd,
.ni-tailwind-namespace samp,
.ni-tailwind-namespace pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

.ni-tailwind-namespace small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

.ni-tailwind-namespace sub,
.ni-tailwind-namespace sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

.ni-tailwind-namespace sub {
  bottom: -0.25em;
}

.ni-tailwind-namespace sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

.ni-tailwind-namespace table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

.ni-tailwind-namespace button,
.ni-tailwind-namespace input,
.ni-tailwind-namespace optgroup,
.ni-tailwind-namespace select,
.ni-tailwind-namespace textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

.ni-tailwind-namespace button,
.ni-tailwind-namespace select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

.ni-tailwind-namespace button,
.ni-tailwind-namespace [type='button'],
.ni-tailwind-namespace [type='reset'],
.ni-tailwind-namespace [type='submit'] {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

.ni-tailwind-namespace :-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

.ni-tailwind-namespace :-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

.ni-tailwind-namespace progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

.ni-tailwind-namespace ::-webkit-inner-spin-button,
.ni-tailwind-namespace ::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

.ni-tailwind-namespace [type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

.ni-tailwind-namespace ::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

.ni-tailwind-namespace ::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

.ni-tailwind-namespace summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

.ni-tailwind-namespace blockquote,
.ni-tailwind-namespace dl,
.ni-tailwind-namespace dd,
.ni-tailwind-namespace h1,
.ni-tailwind-namespace h2,
.ni-tailwind-namespace h3,
.ni-tailwind-namespace h4,
.ni-tailwind-namespace h5,
.ni-tailwind-namespace h6,
.ni-tailwind-namespace hr,
.ni-tailwind-namespace figure,
.ni-tailwind-namespace p,
.ni-tailwind-namespace pre {
  margin: 0;
}

.ni-tailwind-namespace fieldset {
  margin: 0;
  padding: 0;
}

.ni-tailwind-namespace legend {
  padding: 0;
}

.ni-tailwind-namespace ol,
.ni-tailwind-namespace ul,
.ni-tailwind-namespace menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/
.ni-tailwind-namespace dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

.ni-tailwind-namespace textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

.ni-tailwind-namespace input::-moz-placeholder, .ni-tailwind-namespace textarea::-moz-placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

.ni-tailwind-namespace input::placeholder,
.ni-tailwind-namespace textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

.ni-tailwind-namespace button,
.ni-tailwind-namespace [role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/
.ni-tailwind-namespace :disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

.ni-tailwind-namespace img,
.ni-tailwind-namespace svg,
.ni-tailwind-namespace video,
.ni-tailwind-namespace canvas,
.ni-tailwind-namespace audio,
.ni-tailwind-namespace iframe,
.ni-tailwind-namespace embed,
.ni-tailwind-namespace object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

.ni-tailwind-namespace img,
.ni-tailwind-namespace video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */
.ni-tailwind-namespace [hidden] {
  display: none;
}
  .__UNUSED__html {
  font-family: Graphik, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

    font-size: 18px; /* configures \`text-base\` */
    line-height: 1.5;
}

  .ni-tailwind-namespace *:focus {
  outline-offset: 2px;
}

  .ni-tailwind-namespace *:focus:focus-visible {
  outline-width: 2px;
  outline-color: #161819;
}

.ni-tailwind-namespace *, .ni-tailwind-namespace ::before, .ni-tailwind-namespace ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

.ni-tailwind-namespace ::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
.ni-tailwind-namespace .text-2xs {
    font-size: 0.64rem;
    line-height: 1.5;
  }
.ni-tailwind-namespace .text-xs {
    font-size: 0.8rem;
    line-height: 1.5;
  }
.ni-tailwind-namespace .text-sm {
    font-size: 0.89rem;
    line-height: 1.5;
  }
.ni-tailwind-namespace .text-base {
    font-size: 1rem;
    line-height: 1.5;
  }
.ni-tailwind-namespace .text-lg {
    font-size: 1.125rem;
    line-height: 1.5;
  }
.ni-tailwind-namespace .text-xl {
    font-size: 1.266rem;
    line-height: 1.3;
  }
@media (min-width: 1280px) {
    .ni-tailwind-namespace .text-xl {
      font-size: 1.563rem;
    }
  }
.ni-tailwind-namespace .webex-h2 {
    font-size: 1.602rem;
    line-height: 1.3;
  }
@media (min-width: 1280px) {
    .ni-tailwind-namespace .webex-h2 {
      font-size: 2.441rem;
    }
  }
.ni-tailwind-namespace .webex-h2 {
  font-weight: 600;
}
.ni-tailwind-namespace .webex-h3 {
    font-size: 1.424rem;
    line-height: 1.3;
  }
@media (min-width: 1280px) {
    .ni-tailwind-namespace .webex-h3 {
      font-size: 1.953rem;
    }
  }
.ni-tailwind-namespace .webex-h3 {
  font-weight: 600;
}
.ni-tailwind-namespace .webex-h4 {
    font-size: 1.266rem;
    line-height: 1.3;
  }
@media (min-width: 1280px) {
    .ni-tailwind-namespace .webex-h4 {
      font-size: 1.563rem;
    }
  }
.ni-tailwind-namespace .webex-h4 {
  font-weight: 500;
}
.ni-tailwind-namespace .theme-dark .webex-link {
  font-weight: 500;
  --tw-text-opacity: 1;
  color: rgb(248 249 250 / var(--tw-text-opacity));
  text-decoration-line: underline;
  text-decoration-color: transparent;
  transition-property: -webkit-text-decoration;
  transition-property: text-decoration;
  transition-property: text-decoration, -webkit-text-decoration;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
  transition-timing-function: cubic-bezier(0.33, 1, 0.68, 1);
}
.ni-tailwind-namespace .theme-dark .webex-link:hover {
  --tw-text-opacity: 1;
  color: rgb(229 232 235 / var(--tw-text-opacity));
  text-decoration-color: #E5E8EB;
}
.ni-tailwind-namespace .theme-dark .webex-link-standalone {
  --tw-text-opacity: 1;
  color: rgb(248 249 250 / var(--tw-text-opacity));
  text-decoration-line: underline;
  text-decoration-color: transparent;
  transition-property: -webkit-text-decoration;
  transition-property: text-decoration;
  transition-property: text-decoration, -webkit-text-decoration;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
  transition-timing-function: cubic-bezier(0.33, 1, 0.68, 1);
}
.ni-tailwind-namespace .theme-dark .webex-link-standalone:hover {
  --tw-text-opacity: 1;
  color: rgb(229 232 235 / var(--tw-text-opacity));
  text-decoration-color: #E5E8EB;
}
.ni-tailwind-namespace .webex-grid {
  display: grid;
  -moz-column-gap: 25px;
       column-gap: 25px;
}
@media (min-width: 768px) {

  .ni-tailwind-namespace .webex-grid {
    -moz-column-gap: 48px;
         column-gap: 48px;
  }
}
@media (min-width: 1920px) {

  .ni-tailwind-namespace .webex-grid {
    -moz-column-gap: 64px;
         column-gap: 64px;
  }
}
.ni-tailwind-namespace .\\!container {
  margin-left: 24px;
  margin-right: 24px;
}
@media (min-width: 768px) {

  .ni-tailwind-namespace .\\!container {
    margin-left: 40px;
    margin-right: 40px;
  }
}
@media (min-width: 1024px) {

  .ni-tailwind-namespace .\\!container {
    margin-left: auto;
    margin-right: auto;
    max-width: 912px;
  }
}
@media (min-width: 1280px) {

  .ni-tailwind-namespace .\\!container {
    max-width: 1104px;
  }
}
@media (min-width: 1920px) {

  .ni-tailwind-namespace .\\!container {
    max-width: 1472px;
  }
}
.ni-tailwind-namespace .container {
  margin-left: 24px;
  margin-right: 24px;
}
@media (min-width: 768px) {

  .ni-tailwind-namespace .container {
    margin-left: 40px;
    margin-right: 40px;
  }
}
@media (min-width: 1024px) {

  .ni-tailwind-namespace .container {
    margin-left: auto;
    margin-right: auto;
    max-width: 912px;
  }
}
@media (min-width: 1280px) {

  .ni-tailwind-namespace .container {
    max-width: 1104px;
  }
}
@media (min-width: 1920px) {

  .ni-tailwind-namespace .container {
    max-width: 1472px;
  }
}
.ni-tailwind-namespace .webex-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.25rem;
  font-weight: 500;
  transition-property: background;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
  transition-timing-function: cubic-bezier(0.33, 1, 0.68, 1);
}
.ni-tailwind-namespace .webex-btn:disabled {
  pointer-events: none;
}
.ni-tailwind-namespace .webex-btn--primary {
  --tw-bg-opacity: 1;
  background-color: rgb(22 24 25 / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(248 249 250 / var(--tw-text-opacity));
}
.ni-tailwind-namespace .webex-btn--primary:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(52 58 64 / var(--tw-bg-opacity));
}
.ni-tailwind-namespace .webex-btn--primary:disabled {
  --tw-bg-opacity: 1;
  background-color: rgb(134 142 150 / var(--tw-bg-opacity));
}
.ni-tailwind-namespace .theme-dark .webex-btn--primary {
  --tw-bg-opacity: 1;
  background-color: rgb(248 249 250 / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(22 24 25 / var(--tw-text-opacity));
}
.ni-tailwind-namespace .theme-dark .webex-btn--primary:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(238 240 242 / var(--tw-bg-opacity));
}
.ni-tailwind-namespace .theme-dark .webex-btn--primary:disabled {
  --tw-bg-opacity: 1;
  background-color: rgb(220 225 229 / var(--tw-bg-opacity));
}
.ni-tailwind-namespace .webex-btn--secondary {
  background-color: transparent;
  --tw-text-opacity: 1;
  color: rgb(22 24 25 / var(--tw-text-opacity));
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
  --tw-ring-inset: inset;
  --tw-ring-color: currentColor;
  --tw-ring-offset-width: 0px;
}
.ni-tailwind-namespace .webex-btn--secondary:hover {
  --tw-border-opacity: 1;
  border-color: rgb(52 58 64 / var(--tw-border-opacity));
  --tw-text-opacity: 1;
  color: rgb(52 58 64 / var(--tw-text-opacity));
}
.ni-tailwind-namespace .webex-btn--secondary:disabled {
  --tw-border-opacity: 1;
  border-color: rgb(134 142 150 / var(--tw-border-opacity));
  --tw-text-opacity: 1;
  color: rgb(134 142 150 / var(--tw-text-opacity));
}
.ni-tailwind-namespace .theme-dark .webex-btn--secondary {
  --tw-text-opacity: 1;
  color: rgb(248 249 250 / var(--tw-text-opacity));
}
.ni-tailwind-namespace .theme-dark .webex-btn--secondary:hover {
  --tw-border-opacity: 1;
  border-color: rgb(238 240 242 / var(--tw-border-opacity));
  --tw-text-opacity: 1;
  color: rgb(238 240 242 / var(--tw-text-opacity));
}
.ni-tailwind-namespace .theme-dark .webex-btn--secondary:disabled {
  --tw-border-opacity: 1;
  border-color: rgb(220 225 229 / var(--tw-border-opacity));
  --tw-text-opacity: 1;
  color: rgb(220 225 229 / var(--tw-text-opacity));
}
.ni-tailwind-namespace .webex-btn--ghost {
  background-color: transparent;
  --tw-text-opacity: 1;
  color: rgb(22 24 25 / var(--tw-text-opacity));
}
.ni-tailwind-namespace .webex-btn--ghost:hover {
  text-decoration-line: underline;
}
.ni-tailwind-namespace .webex-btn--ghost:disabled {
  --tw-text-opacity: 1;
  color: rgb(134 142 150 / var(--tw-text-opacity));
}
.ni-tailwind-namespace .theme-dark .webex-btn--ghost {
  --tw-text-opacity: 1;
  color: rgb(248 249 250 / var(--tw-text-opacity));
}
.ni-tailwind-namespace .theme-dark .webex-btn--ghost:disabled {
  --tw-text-opacity: 1;
  color: rgb(220 225 229 / var(--tw-text-opacity));
}
.ni-tailwind-namespace .webex-btn--highlight {
  --tw-bg-opacity: 1;
  background-color: rgb(62 140 187 / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
.ni-tailwind-namespace .webex-btn--highlight:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(43 123 172 / var(--tw-bg-opacity));
}
.ni-tailwind-namespace .webex-btn--highlight:disabled {
  --tw-bg-opacity: 1;
  background-color: rgb(187 193 199 / var(--tw-bg-opacity));
}
.ni-tailwind-namespace .webex-btn--xs {
    font-size: 0.8rem;
    line-height: 1.5;
    padding-left: 12px;
    padding-right: 12px;
    padding-top: 6px;
    padding-bottom: 6px;
  }
.ni-tailwind-namespace .webex-btn--sm {
    font-size: 0.89rem;
    line-height: 1.5;
    padding-left: 16px;
    padding-right: 16px;
    padding-top: 8px;
    padding-bottom: 8px;
  }
.ni-tailwind-namespace .webex-btn--regular {
    font-size: 1rem;
    line-height: 1.5;
    padding-top: 8px;
    padding-bottom: 8px;
    padding-left: 24px;
    padding-right: 24px;
  }
.ni-tailwind-namespace .webex-btn--lg {
    font-size: 1.125rem;
    line-height: 1.5;
    padding-top: 8px;
    padding-bottom: 8px;
    padding-left: 24px;
    padding-right: 24px;
  }
.ni-tailwind-namespace .webex-btn--xs.webex-btn--ghost,
  .ni-tailwind-namespace .webex-btn--sm.webex-btn--ghost,
  .ni-tailwind-namespace .webex-btn--regular.webex-btn--ghost,
  .ni-tailwind-namespace .webex-btn--lg.webex-btn--ghost {
  padding-left: 0px;
  padding-right: 0px;
}
.ni-tailwind-namespace .webex-btn--loading {
  position: relative;
}
.ni-tailwind-namespace .webex-checkbox:checked ~ .webex-checkmark {
  display: block;
}
.ni-tailwind-namespace .webex-media-btn {
  display: inline-flex;
  align-items: center;
  --tw-text-opacity: 1;
  color: rgb(22 24 25 / var(--tw-text-opacity));
}
.ni-tailwind-namespace .webex-media-btn:hover {
  --tw-text-opacity: 1;
  color: rgb(52 58 64 / var(--tw-text-opacity));
}
.ni-tailwind-namespace .theme-dark .webex-media-btn {
  display: inline-flex;
  align-items: center;
  --tw-text-opacity: 1;
  color: rgb(248 249 250 / var(--tw-text-opacity));
}
.ni-tailwind-namespace .theme-dark .webex-media-btn:hover {
  --tw-text-opacity: 1;
  color: rgb(238 240 242 / var(--tw-text-opacity));
}
@keyframes dash {
    0% {
      stroke-dasharray: 1, 150;
      stroke-dashoffset: 0;
    }
    50% {
      stroke-dasharray: 90, 150;
      stroke-dashoffset: -35;
    }
    100% {
      stroke-dasharray: 90, 150;
      stroke-dashoffset: -124;
    }
  }
@keyframes spin {
    100% {
      transform: rotate(360deg);
    }
  }
@keyframes fadein {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
.ni-tailwind-namespace .webex-animation-dash {
    animation: dash 1.5s ease-in-out infinite;
  }
.ni-tailwind-namespace .webex-animation-spin {
    animation: spin 1.5s linear infinite;
  }
.ni-tailwind-namespace .sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
.ni-tailwind-namespace .not-sr-only {
  position: static;
  width: auto;
  height: auto;
  padding: 0;
  margin: 0;
  overflow: visible;
  clip: auto;
  white-space: normal;
}
.ni-tailwind-namespace .pointer-events-none {
  pointer-events: none;
}
.ni-tailwind-namespace .pointer-events-auto {
  pointer-events: auto;
}
.ni-tailwind-namespace .visible {
  visibility: visible;
}
.ni-tailwind-namespace .invisible {
  visibility: hidden;
}
.ni-tailwind-namespace .collapse {
  visibility: collapse;
}
.ni-tailwind-namespace .static {
  position: static;
}
.ni-tailwind-namespace .fixed {
  position: fixed;
}
.ni-tailwind-namespace .absolute {
  position: absolute;
}
.ni-tailwind-namespace .relative {
  position: relative;
}
.ni-tailwind-namespace .sticky {
  position: sticky;
}
.ni-tailwind-namespace .-inset-1 {
  inset: -8px;
}
.ni-tailwind-namespace .inset-0 {
  inset: 0px;
}
.ni-tailwind-namespace .inset-x-0 {
  left: 0px;
  right: 0px;
}
.ni-tailwind-namespace .-top-0 {
  top: -0px;
}
.ni-tailwind-namespace .-top-0\\.5 {
  top: -4px;
}
.ni-tailwind-namespace .-top-\\[17px\\] {
  top: -17px;
}
.ni-tailwind-namespace .left-0 {
  left: 0px;
}
.ni-tailwind-namespace .left-0\\.5 {
  left: 4px;
}
.ni-tailwind-namespace .left-1\\/2 {
  left: 50%;
}
.ni-tailwind-namespace .left-2 {
  left: 16px;
}
.ni-tailwind-namespace .right-0 {
  right: 0px;
}
.ni-tailwind-namespace .right-2 {
  right: 16px;
}
.ni-tailwind-namespace .top-0 {
  top: 0px;
}
.ni-tailwind-namespace .top-0\\.5 {
  top: 4px;
}
.ni-tailwind-namespace .top-1\\/2 {
  top: 50%;
}
.ni-tailwind-namespace .top-1\\/3 {
  top: 33.333333%;
}
.ni-tailwind-namespace .top-2 {
  top: 16px;
}
.ni-tailwind-namespace .isolate {
  isolation: isolate;
}
.ni-tailwind-namespace .isolation-auto {
  isolation: auto;
}
.ni-tailwind-namespace .z-10 {
  z-index: 10;
}
.ni-tailwind-namespace .z-50 {
  z-index: 50;
}
.ni-tailwind-namespace .col-span-2 {
  grid-column: span 2 / span 2;
}
.ni-tailwind-namespace .col-span-3 {
  grid-column: span 3 / span 3;
}
.ni-tailwind-namespace .col-span-4 {
  grid-column: span 4 / span 4;
}
.ni-tailwind-namespace .col-span-6 {
  grid-column: span 6 / span 6;
}
.ni-tailwind-namespace .col-span-full {
  grid-column: 1 / -1;
}
.ni-tailwind-namespace .col-start-1 {
  grid-column-start: 1;
}
.ni-tailwind-namespace .float-start {
  float: inline-start;
}
.ni-tailwind-namespace .float-end {
  float: inline-end;
}
.ni-tailwind-namespace .float-right {
  float: right;
}
.ni-tailwind-namespace .float-left {
  float: left;
}
.ni-tailwind-namespace .float-none {
  float: none;
}
.ni-tailwind-namespace .clear-start {
  clear: inline-start;
}
.ni-tailwind-namespace .clear-end {
  clear: inline-end;
}
.ni-tailwind-namespace .clear-left {
  clear: left;
}
.ni-tailwind-namespace .clear-right {
  clear: right;
}
.ni-tailwind-namespace .clear-both {
  clear: both;
}
.ni-tailwind-namespace .clear-none {
  clear: none;
}
.ni-tailwind-namespace .m-0 {
  margin: 0px;
}
.ni-tailwind-namespace .m-\\[\\FFFD C\\FFFD\\E\\FFFD\\FFFD\\13W\\] {
  margin: �C���W;
}
.ni-tailwind-namespace .mx-1 {
  margin-left: 8px;
  margin-right: 8px;
}
.ni-tailwind-namespace .mx-auto {
  margin-left: auto;
  margin-right: auto;
}
.ni-tailwind-namespace .my-0 {
  margin-top: 0px;
  margin-bottom: 0px;
}
.ni-tailwind-namespace .my-0\\.25 {
  margin-top: 2px;
  margin-bottom: 2px;
}
.ni-tailwind-namespace .my-1 {
  margin-top: 8px;
  margin-bottom: 8px;
}
.ni-tailwind-namespace .my-12 {
  margin-top: 96px;
  margin-bottom: 96px;
}
.ni-tailwind-namespace .my-2 {
  margin-top: 16px;
  margin-bottom: 16px;
}
.ni-tailwind-namespace .my-3 {
  margin-top: 24px;
  margin-bottom: 24px;
}
.ni-tailwind-namespace .my-4 {
  margin-top: 32px;
  margin-bottom: 32px;
}
.ni-tailwind-namespace .-ml-\\[1px\\] {
  margin-left: -1px;
}
.ni-tailwind-namespace .mb-1 {
  margin-bottom: 8px;
}
.ni-tailwind-namespace .mb-1\\.5 {
  margin-bottom: 12px;
}
.ni-tailwind-namespace .mb-12 {
  margin-bottom: 96px;
}
.ni-tailwind-namespace .mb-2 {
  margin-bottom: 16px;
}
.ni-tailwind-namespace .mb-3 {
  margin-bottom: 24px;
}
.ni-tailwind-namespace .mb-4 {
  margin-bottom: 32px;
}
.ni-tailwind-namespace .mb-5 {
  margin-bottom: 40px;
}
.ni-tailwind-namespace .mb-6 {
  margin-bottom: 48px;
}
.ni-tailwind-namespace .ml-0 {
  margin-left: 0px;
}
.ni-tailwind-namespace .ml-0\\.5 {
  margin-left: 4px;
}
.ni-tailwind-namespace .ml-1 {
  margin-left: 8px;
}
.ni-tailwind-namespace .ml-1\\.5 {
  margin-left: 12px;
}
.ni-tailwind-namespace .ml-3 {
  margin-left: 24px;
}
.ni-tailwind-namespace .ml-auto {
  margin-left: auto;
}
.ni-tailwind-namespace .mr-0 {
  margin-right: 0px;
}
.ni-tailwind-namespace .mr-0\\.5 {
  margin-right: 4px;
}
.ni-tailwind-namespace .mr-1 {
  margin-right: 8px;
}
.ni-tailwind-namespace .mr-2 {
  margin-right: 16px;
}
.ni-tailwind-namespace .mr-4 {
  margin-right: 32px;
}
.ni-tailwind-namespace .mt-0 {
  margin-top: 0px;
}
.ni-tailwind-namespace .mt-0\\.5 {
  margin-top: 4px;
}
.ni-tailwind-namespace .mt-1 {
  margin-top: 8px;
}
.ni-tailwind-namespace .mt-12 {
  margin-top: 96px;
}
.ni-tailwind-namespace .mt-2 {
  margin-top: 16px;
}
.ni-tailwind-namespace .mt-3 {
  margin-top: 24px;
}
.ni-tailwind-namespace .mt-4 {
  margin-top: 32px;
}
.ni-tailwind-namespace .mt-5 {
  margin-top: 40px;
}
.ni-tailwind-namespace .mt-6 {
  margin-top: 48px;
}
.ni-tailwind-namespace .mt-8 {
  margin-top: 64px;
}
.ni-tailwind-namespace .mt-\\[4px\\] {
  margin-top: 4px;
}
.ni-tailwind-namespace .box-border {
  box-sizing: border-box;
}
.ni-tailwind-namespace .box-content {
  box-sizing: content-box;
}
.ni-tailwind-namespace .line-clamp-none {
  overflow: visible;
  display: block;
  -webkit-box-orient: horizontal;
  -webkit-line-clamp: none;
}
.ni-tailwind-namespace .\\!block {
  display: block !important;
}
.ni-tailwind-namespace .block {
  display: block;
}
.ni-tailwind-namespace .inline-block {
  display: inline-block;
}
.ni-tailwind-namespace .inline {
  display: inline;
}
.ni-tailwind-namespace .flex {
  display: flex;
}
.ni-tailwind-namespace .inline-flex {
  display: inline-flex;
}
.ni-tailwind-namespace .\\!table {
  display: table !important;
}
.ni-tailwind-namespace .table {
  display: table;
}
.ni-tailwind-namespace .inline-table {
  display: inline-table;
}
.ni-tailwind-namespace .table-caption {
  display: table-caption;
}
.ni-tailwind-namespace .table-cell {
  display: table-cell;
}
.ni-tailwind-namespace .table-column {
  display: table-column;
}
.ni-tailwind-namespace .table-column-group {
  display: table-column-group;
}
.ni-tailwind-namespace .table-footer-group {
  display: table-footer-group;
}
.ni-tailwind-namespace .table-header-group {
  display: table-header-group;
}
.ni-tailwind-namespace .table-row-group {
  display: table-row-group;
}
.ni-tailwind-namespace .table-row {
  display: table-row;
}
.ni-tailwind-namespace .flow-root {
  display: flow-root;
}
.ni-tailwind-namespace .\\!grid {
  display: grid !important;
}
.ni-tailwind-namespace .grid {
  display: grid;
}
.ni-tailwind-namespace .inline-grid {
  display: inline-grid;
}
.ni-tailwind-namespace .contents {
  display: contents;
}
.ni-tailwind-namespace .list-item {
  display: list-item;
}
.ni-tailwind-namespace .hidden {
  display: none;
}
.ni-tailwind-namespace .aspect-\\[140\\/80\\] {
  aspect-ratio: 140/80;
}
.ni-tailwind-namespace .size-2 {
  width: 16px;
  height: 16px;
}
.ni-tailwind-namespace .size-2\\.5 {
  width: 20px;
  height: 20px;
}
.ni-tailwind-namespace .size-3 {
  width: 24px;
  height: 24px;
}
.ni-tailwind-namespace .size-full {
  width: 100%;
  height: 100%;
}
.ni-tailwind-namespace .h-10 {
  height: 80px;
}
.ni-tailwind-namespace .h-2 {
  height: 16px;
}
.ni-tailwind-namespace .h-3 {
  height: 24px;
}
.ni-tailwind-namespace .h-4 {
  height: 32px;
}
.ni-tailwind-namespace .h-5 {
  height: 40px;
}
.ni-tailwind-namespace .h-6 {
  height: 48px;
}
.ni-tailwind-namespace .h-7 {
  height: 56px;
}
.ni-tailwind-namespace .h-8 {
  height: 64px;
}
.ni-tailwind-namespace .h-\\[13px\\] {
  height: 13px;
}
.ni-tailwind-namespace .h-\\[14px\\] {
  height: 14px;
}
.ni-tailwind-namespace .h-\\[1px\\] {
  height: 1px;
}
.ni-tailwind-namespace .h-\\[20px\\] {
  height: 20px;
}
.ni-tailwind-namespace .h-\\[26px\\] {
  height: 26px;
}
.ni-tailwind-namespace .h-\\[2px\\] {
  height: 2px;
}
.ni-tailwind-namespace .h-\\[300px\\] {
  height: 300px;
}
.ni-tailwind-namespace .h-\\[32px\\] {
  height: 32px;
}
.ni-tailwind-namespace .h-full {
  height: 100%;
}
.ni-tailwind-namespace .max-h-\\[450px\\] {
  max-height: 450px;
}
.ni-tailwind-namespace .min-h-5 {
  min-height: 40px;
}
.ni-tailwind-namespace .w-2\\/3 {
  width: 66.666667%;
}
.ni-tailwind-namespace .w-3 {
  width: 24px;
}
.ni-tailwind-namespace .w-6 {
  width: 48px;
}
.ni-tailwind-namespace .w-7 {
  width: 56px;
}
.ni-tailwind-namespace .w-8 {
  width: 64px;
}
.ni-tailwind-namespace .w-\\[14px\\] {
  width: 14px;
}
.ni-tailwind-namespace .w-\\[16px\\] {
  width: 16px;
}
.ni-tailwind-namespace .w-\\[1px\\] {
  width: 1px;
}
.ni-tailwind-namespace .w-\\[30\\%\\] {
  width: 30%;
}
.ni-tailwind-namespace .w-\\[this-is\\\\\\\\\\] {
  width: this-is\\\\;
}
.ni-tailwind-namespace .w-\\[this-is\\] {
  width: this-is;
}
.ni-tailwind-namespace .w-\\[weird-and-invalid\\] {
  width: weird-and-invalid;
}
.ni-tailwind-namespace .w-full {
  width: 100%;
}
.ni-tailwind-namespace .min-w-\\[128px\\] {
  min-width: 128px;
}
.ni-tailwind-namespace .min-w-full {
  min-width: 100%;
}
.ni-tailwind-namespace .max-w-\\[400px\\] {
  max-width: 400px;
}
.ni-tailwind-namespace .max-w-\\[480px\\] {
  max-width: 480px;
}
.ni-tailwind-namespace .flex-1 {
  flex: 1 1 0%;
}
.ni-tailwind-namespace .flex-shrink {
  flex-shrink: 1;
}
.ni-tailwind-namespace .flex-shrink-0 {
  flex-shrink: 0;
}
.ni-tailwind-namespace .shrink {
  flex-shrink: 1;
}
.ni-tailwind-namespace .flex-grow {
  flex-grow: 1;
}
.ni-tailwind-namespace .grow {
  flex-grow: 1;
}
.ni-tailwind-namespace .table-auto {
  table-layout: auto;
}
.ni-tailwind-namespace .table-fixed {
  table-layout: fixed;
}
.ni-tailwind-namespace .caption-top {
  caption-side: top;
}
.ni-tailwind-namespace .caption-bottom {
  caption-side: bottom;
}
.ni-tailwind-namespace .border-collapse {
  border-collapse: collapse;
}
.ni-tailwind-namespace .border-separate {
  border-collapse: separate;
}
.ni-tailwind-namespace .origin-left {
  transform-origin: left;
}
.ni-tailwind-namespace .origin-top-left {
  transform-origin: top left;
}
.ni-tailwind-namespace .-translate-x-1\\/2 {
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.ni-tailwind-namespace .-translate-y-1 {
  --tw-translate-y: -8px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.ni-tailwind-namespace .-translate-y-1\\.5 {
  --tw-translate-y: -12px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.ni-tailwind-namespace .-translate-y-1\\/2 {
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.ni-tailwind-namespace .-translate-y-2 {
  --tw-translate-y: -16px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.ni-tailwind-namespace .-translate-y-2\\.5 {
  --tw-translate-y: -20px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.ni-tailwind-namespace .translate-y-0 {
  --tw-translate-y: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.ni-tailwind-namespace .translate-y-4 {
  --tw-translate-y: 32px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.ni-tailwind-namespace .translate-y-\\[2px\\] {
  --tw-translate-y: 2px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.ni-tailwind-namespace .rotate-0 {
  --tw-rotate: 0deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.ni-tailwind-namespace .rotate-180 {
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.ni-tailwind-namespace .rotate-45 {
  --tw-rotate: 45deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.ni-tailwind-namespace .rotate-\\[-45deg\\] {
  --tw-rotate: -45deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.ni-tailwind-namespace .scale-75 {
  --tw-scale-x: .75;
  --tw-scale-y: .75;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.ni-tailwind-namespace .\\!transform {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.ni-tailwind-namespace .transform {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.ni-tailwind-namespace .transform-cpu {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.ni-tailwind-namespace .transform-gpu {
  transform: translate3d(var(--tw-translate-x), var(--tw-translate-y), 0) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.ni-tailwind-namespace .transform-none {
  transform: none;
}
@keyframes pulse {

  50% {
    opacity: .5;
  }
}
.ni-tailwind-namespace .animate-pulse {
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}
@keyframes shake {

  0% {
    transform: translateX(0rem);
  }

  6.5% {
    transform: translateX(-6px) rotateY(-9deg);
  }

  18.5% {
    transform: translateX(5px) rotateY(7deg);
  }

  31.5% {
    transform: translateX(-3px) rotateY(-5deg);
  }

  43.5% {
    transform: translateX(2px) rotateY(3deg);
  }

  50% {
    transform: translateX(0);
  }

  25% {
    transform: translateX(-1rem);
  }

  75% {
    transform: translateX(1rem);
  }

  100% {
    transform: translateX(0rem);
  }
}
.ni-tailwind-namespace .animate-shake {
  animation: shake .5s both;
}
.ni-tailwind-namespace .cursor-default {
  cursor: default;
}
.ni-tailwind-namespace .cursor-pointer {
  cursor: pointer;
}
.ni-tailwind-namespace .touch-auto {
  touch-action: auto;
}
.ni-tailwind-namespace .touch-none {
  touch-action: none;
}
.ni-tailwind-namespace .touch-pan-x {
  --tw-pan-x: pan-x;
  touch-action: var(--tw-pan-x) var(--tw-pan-y) var(--tw-pinch-zoom);
}
.ni-tailwind-namespace .touch-pan-left {
  --tw-pan-x: pan-left;
  touch-action: var(--tw-pan-x) var(--tw-pan-y) var(--tw-pinch-zoom);
}
.ni-tailwind-namespace .touch-pan-right {
  --tw-pan-x: pan-right;
  touch-action: var(--tw-pan-x) var(--tw-pan-y) var(--tw-pinch-zoom);
}
.ni-tailwind-namespace .touch-pan-y {
  --tw-pan-y: pan-y;
  touch-action: var(--tw-pan-x) var(--tw-pan-y) var(--tw-pinch-zoom);
}
.ni-tailwind-namespace .touch-pan-up {
  --tw-pan-y: pan-up;
  touch-action: var(--tw-pan-x) var(--tw-pan-y) var(--tw-pinch-zoom);
}
.ni-tailwind-namespace .touch-pan-down {
  --tw-pan-y: pan-down;
  touch-action: var(--tw-pan-x) var(--tw-pan-y) var(--tw-pinch-zoom);
}
.ni-tailwind-namespace .touch-pinch-zoom {
  --tw-pinch-zoom: pinch-zoom;
  touch-action: var(--tw-pan-x) var(--tw-pan-y) var(--tw-pinch-zoom);
}
.ni-tailwind-namespace .touch-manipulation {
  touch-action: manipulation;
}
.ni-tailwind-namespace .select-none {
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
}
.ni-tailwind-namespace .select-text {
  -webkit-user-select: text;
     -moz-user-select: text;
          user-select: text;
}
.ni-tailwind-namespace .select-all {
  -webkit-user-select: all;
     -moz-user-select: all;
          user-select: all;
}
.ni-tailwind-namespace .select-auto {
  -webkit-user-select: auto;
     -moz-user-select: auto;
          user-select: auto;
}
.ni-tailwind-namespace .resize-none {
  resize: none;
}
.ni-tailwind-namespace .resize-y {
  resize: vertical;
}
.ni-tailwind-namespace .resize-x {
  resize: horizontal;
}
.ni-tailwind-namespace .resize {
  resize: both;
}
.ni-tailwind-namespace .snap-none {
  scroll-snap-type: none;
}
.ni-tailwind-namespace .snap-x {
  scroll-snap-type: x var(--tw-scroll-snap-strictness);
}
.ni-tailwind-namespace .snap-y {
  scroll-snap-type: y var(--tw-scroll-snap-strictness);
}
.ni-tailwind-namespace .snap-both {
  scroll-snap-type: both var(--tw-scroll-snap-strictness);
}
.ni-tailwind-namespace .snap-mandatory {
  --tw-scroll-snap-strictness: mandatory;
}
.ni-tailwind-namespace .snap-proximity {
  --tw-scroll-snap-strictness: proximity;
}
.ni-tailwind-namespace .snap-start {
  scroll-snap-align: start;
}
.ni-tailwind-namespace .snap-end {
  scroll-snap-align: end;
}
.ni-tailwind-namespace .snap-center {
  scroll-snap-align: center;
}
.ni-tailwind-namespace .snap-align-none {
  scroll-snap-align: none;
}
.ni-tailwind-namespace .snap-normal {
  scroll-snap-stop: normal;
}
.ni-tailwind-namespace .snap-always {
  scroll-snap-stop: always;
}
.ni-tailwind-namespace .list-inside {
  list-style-position: inside;
}
.ni-tailwind-namespace .list-outside {
  list-style-position: outside;
}
.ni-tailwind-namespace .list-disc {
  list-style-type: disc;
}
.ni-tailwind-namespace .list-none {
  list-style-type: none;
}
.ni-tailwind-namespace .appearance-none {
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
}
.ni-tailwind-namespace .appearance-auto {
  -webkit-appearance: auto;
     -moz-appearance: auto;
          appearance: auto;
}
.ni-tailwind-namespace .break-before-auto {
  -moz-column-break-before: auto;
       break-before: auto;
}
.ni-tailwind-namespace .break-before-avoid {
  -moz-column-break-before: avoid;
       break-before: avoid;
}
.ni-tailwind-namespace .break-before-all {
  -moz-column-break-before: all;
       break-before: all;
}
.ni-tailwind-namespace .break-before-avoid-page {
  -moz-column-break-before: avoid;
       break-before: avoid-page;
}
.ni-tailwind-namespace .break-before-page {
  -moz-column-break-before: page;
       break-before: page;
}
.ni-tailwind-namespace .break-before-left {
  -moz-column-break-before: left;
       break-before: left;
}
.ni-tailwind-namespace .break-before-right {
  -moz-column-break-before: right;
       break-before: right;
}
.ni-tailwind-namespace .break-before-column {
  -moz-column-break-before: column;
       break-before: column;
}
.ni-tailwind-namespace .break-inside-auto {
  -moz-column-break-inside: auto;
       break-inside: auto;
}
.ni-tailwind-namespace .break-inside-avoid {
  -moz-column-break-inside: avoid;
       break-inside: avoid;
}
.ni-tailwind-namespace .break-inside-avoid-page {
  break-inside: avoid-page;
}
.ni-tailwind-namespace .break-inside-avoid-column {
  -moz-column-break-inside: avoid;
       break-inside: avoid-column;
}
.ni-tailwind-namespace .break-after-auto {
  -moz-column-break-after: auto;
       break-after: auto;
}
.ni-tailwind-namespace .break-after-avoid {
  -moz-column-break-after: avoid;
       break-after: avoid;
}
.ni-tailwind-namespace .break-after-all {
  -moz-column-break-after: all;
       break-after: all;
}
.ni-tailwind-namespace .break-after-avoid-page {
  -moz-column-break-after: avoid;
       break-after: avoid-page;
}
.ni-tailwind-namespace .break-after-page {
  -moz-column-break-after: page;
       break-after: page;
}
.ni-tailwind-namespace .break-after-left {
  -moz-column-break-after: left;
       break-after: left;
}
.ni-tailwind-namespace .break-after-right {
  -moz-column-break-after: right;
       break-after: right;
}
.ni-tailwind-namespace .break-after-column {
  -moz-column-break-after: column;
       break-after: column;
}
.ni-tailwind-namespace .grid-flow-row {
  grid-auto-flow: row;
}
.ni-tailwind-namespace .grid-flow-col {
  grid-auto-flow: column;
}
.ni-tailwind-namespace .grid-flow-dense {
  grid-auto-flow: dense;
}
.ni-tailwind-namespace .grid-flow-row-dense {
  grid-auto-flow: row dense;
}
.ni-tailwind-namespace .grid-flow-col-dense {
  grid-auto-flow: column dense;
}
.ni-tailwind-namespace .auto-rows-min {
  grid-auto-rows: min-content;
}
.ni-tailwind-namespace .grid-cols-1 {
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
.ni-tailwind-namespace .grid-cols-4 {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}
.ni-tailwind-namespace .grid-cols-6 {
  grid-template-columns: repeat(6, minmax(0, 1fr));
}
.ni-tailwind-namespace .flex-row {
  flex-direction: row;
}
.ni-tailwind-namespace .flex-row-reverse {
  flex-direction: row-reverse;
}
.ni-tailwind-namespace .flex-col {
  flex-direction: column;
}
.ni-tailwind-namespace .flex-col-reverse {
  flex-direction: column-reverse;
}
.ni-tailwind-namespace .flex-wrap {
  flex-wrap: wrap;
}
.ni-tailwind-namespace .flex-wrap-reverse {
  flex-wrap: wrap-reverse;
}
.ni-tailwind-namespace .flex-nowrap {
  flex-wrap: nowrap;
}
.ni-tailwind-namespace .place-content-center {
  place-content: center;
}
.ni-tailwind-namespace .place-content-start {
  place-content: start;
}
.ni-tailwind-namespace .place-content-end {
  place-content: end;
}
.ni-tailwind-namespace .place-content-between {
  place-content: space-between;
}
.ni-tailwind-namespace .place-content-around {
  place-content: space-around;
}
.ni-tailwind-namespace .place-content-evenly {
  place-content: space-evenly;
}
.ni-tailwind-namespace .place-content-baseline {
  place-content: baseline;
}
.ni-tailwind-namespace .place-content-stretch {
  place-content: stretch;
}
.ni-tailwind-namespace .place-items-start {
  place-items: start;
}
.ni-tailwind-namespace .place-items-end {
  place-items: end;
}
.ni-tailwind-namespace .place-items-center {
  place-items: center;
}
.ni-tailwind-namespace .place-items-baseline {
  place-items: baseline;
}
.ni-tailwind-namespace .place-items-stretch {
  place-items: stretch;
}
.ni-tailwind-namespace .content-normal {
  align-content: normal;
}
.ni-tailwind-namespace .content-center {
  align-content: center;
}
.ni-tailwind-namespace .content-start {
  align-content: flex-start;
}
.ni-tailwind-namespace .content-end {
  align-content: flex-end;
}
.ni-tailwind-namespace .content-between {
  align-content: space-between;
}
.ni-tailwind-namespace .content-around {
  align-content: space-around;
}
.ni-tailwind-namespace .content-evenly {
  align-content: space-evenly;
}
.ni-tailwind-namespace .content-baseline {
  align-content: baseline;
}
.ni-tailwind-namespace .content-stretch {
  align-content: stretch;
}
.ni-tailwind-namespace .items-start {
  align-items: flex-start;
}
.ni-tailwind-namespace .items-end {
  align-items: flex-end;
}
.ni-tailwind-namespace .items-center {
  align-items: center;
}
.ni-tailwind-namespace .items-baseline {
  align-items: baseline;
}
.ni-tailwind-namespace .items-stretch {
  align-items: stretch;
}
.ni-tailwind-namespace .justify-normal {
  justify-content: normal;
}
.ni-tailwind-namespace .justify-start {
  justify-content: flex-start;
}
.ni-tailwind-namespace .justify-end {
  justify-content: flex-end;
}
.ni-tailwind-namespace .justify-center {
  justify-content: center;
}
.ni-tailwind-namespace .justify-between {
  justify-content: space-between;
}
.ni-tailwind-namespace .justify-around {
  justify-content: space-around;
}
.ni-tailwind-namespace .justify-evenly {
  justify-content: space-evenly;
}
.ni-tailwind-namespace .justify-stretch {
  justify-content: stretch;
}
.ni-tailwind-namespace .justify-items-start {
  justify-items: start;
}
.ni-tailwind-namespace .justify-items-end {
  justify-items: end;
}
.ni-tailwind-namespace .justify-items-center {
  justify-items: center;
}
.ni-tailwind-namespace .justify-items-stretch {
  justify-items: stretch;
}
.ni-tailwind-namespace .gap-2 {
  gap: 16px;
}
.ni-tailwind-namespace .gap-3 {
  gap: 24px;
}
.ni-tailwind-namespace .gap-4 {
  gap: 32px;
}
.ni-tailwind-namespace .gap-x-5 {
  -moz-column-gap: 40px;
       column-gap: 40px;
}
.ni-tailwind-namespace .space-x-2 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(16px * var(--tw-space-x-reverse));
  margin-left: calc(16px * calc(1 - var(--tw-space-x-reverse)));
}
.ni-tailwind-namespace .space-y-1 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(8px * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(8px * var(--tw-space-y-reverse));
}
.ni-tailwind-namespace .space-y-2 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(16px * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(16px * var(--tw-space-y-reverse));
}
.ni-tailwind-namespace .space-y-4 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(32px * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(32px * var(--tw-space-y-reverse));
}
.ni-tailwind-namespace .space-y-reverse > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 1;
}
.ni-tailwind-namespace .space-x-reverse > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 1;
}
.ni-tailwind-namespace .divide-x > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-x-reverse: 0;
  border-right-width: calc(1px * var(--tw-divide-x-reverse));
  border-left-width: calc(1px * calc(1 - var(--tw-divide-x-reverse)));
}
.ni-tailwind-namespace .divide-y > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-y-reverse: 0;
  border-top-width: calc(1px * calc(1 - var(--tw-divide-y-reverse)));
  border-bottom-width: calc(1px * var(--tw-divide-y-reverse));
}
.ni-tailwind-namespace .divide-y-reverse > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-y-reverse: 1;
}
.ni-tailwind-namespace .divide-x-reverse > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-x-reverse: 1;
}
.ni-tailwind-namespace .divide-solid > :not([hidden]) ~ :not([hidden]) {
  border-style: solid;
}
.ni-tailwind-namespace .divide-dashed > :not([hidden]) ~ :not([hidden]) {
  border-style: dashed;
}
.ni-tailwind-namespace .divide-dotted > :not([hidden]) ~ :not([hidden]) {
  border-style: dotted;
}
.ni-tailwind-namespace .divide-double > :not([hidden]) ~ :not([hidden]) {
  border-style: double;
}
.ni-tailwind-namespace .divide-none > :not([hidden]) ~ :not([hidden]) {
  border-style: none;
}
.ni-tailwind-namespace .divide-\\[\\#DCE1E5\\] > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(220 225 229 / var(--tw-divide-opacity));
}
.ni-tailwind-namespace .place-self-auto {
  place-self: auto;
}
.ni-tailwind-namespace .place-self-start {
  place-self: start;
}
.ni-tailwind-namespace .place-self-end {
  place-self: end;
}
.ni-tailwind-namespace .place-self-center {
  place-self: center;
}
.ni-tailwind-namespace .place-self-stretch {
  place-self: stretch;
}
.ni-tailwind-namespace .self-auto {
  align-self: auto;
}
.ni-tailwind-namespace .self-start {
  align-self: flex-start;
}
.ni-tailwind-namespace .self-end {
  align-self: flex-end;
}
.ni-tailwind-namespace .self-center {
  align-self: center;
}
.ni-tailwind-namespace .self-stretch {
  align-self: stretch;
}
.ni-tailwind-namespace .self-baseline {
  align-self: baseline;
}
.ni-tailwind-namespace .justify-self-auto {
  justify-self: auto;
}
.ni-tailwind-namespace .justify-self-start {
  justify-self: start;
}
.ni-tailwind-namespace .justify-self-end {
  justify-self: end;
}
.ni-tailwind-namespace .justify-self-center {
  justify-self: center;
}
.ni-tailwind-namespace .justify-self-stretch {
  justify-self: stretch;
}
.ni-tailwind-namespace .overflow-auto {
  overflow: auto;
}
.ni-tailwind-namespace .overflow-hidden {
  overflow: hidden;
}
.ni-tailwind-namespace .overflow-clip {
  overflow: clip;
}
.ni-tailwind-namespace .overflow-visible {
  overflow: visible;
}
.ni-tailwind-namespace .overflow-scroll {
  overflow: scroll;
}
.ni-tailwind-namespace .overflow-x-auto {
  overflow-x: auto;
}
.ni-tailwind-namespace .overflow-y-auto {
  overflow-y: auto;
}
.ni-tailwind-namespace .overflow-x-hidden {
  overflow-x: hidden;
}
.ni-tailwind-namespace .overflow-y-hidden {
  overflow-y: hidden;
}
.ni-tailwind-namespace .overflow-x-clip {
  overflow-x: clip;
}
.ni-tailwind-namespace .overflow-y-clip {
  overflow-y: clip;
}
.ni-tailwind-namespace .overflow-x-visible {
  overflow-x: visible;
}
.ni-tailwind-namespace .overflow-y-visible {
  overflow-y: visible;
}
.ni-tailwind-namespace .overflow-x-scroll {
  overflow-x: scroll;
}
.ni-tailwind-namespace .overflow-y-scroll {
  overflow-y: scroll;
}
.ni-tailwind-namespace .overscroll-auto {
  overscroll-behavior: auto;
}
.ni-tailwind-namespace .overscroll-contain {
  overscroll-behavior: contain;
}
.ni-tailwind-namespace .overscroll-none {
  overscroll-behavior: none;
}
.ni-tailwind-namespace .overscroll-y-auto {
  overscroll-behavior-y: auto;
}
.ni-tailwind-namespace .overscroll-y-contain {
  overscroll-behavior-y: contain;
}
.ni-tailwind-namespace .overscroll-y-none {
  overscroll-behavior-y: none;
}
.ni-tailwind-namespace .overscroll-x-auto {
  overscroll-behavior-x: auto;
}
.ni-tailwind-namespace .overscroll-x-contain {
  overscroll-behavior-x: contain;
}
.ni-tailwind-namespace .overscroll-x-none {
  overscroll-behavior-x: none;
}
.ni-tailwind-namespace .scroll-auto {
  scroll-behavior: auto;
}
.ni-tailwind-namespace .scroll-smooth {
  scroll-behavior: smooth;
}
.ni-tailwind-namespace .truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.ni-tailwind-namespace .overflow-ellipsis {
  text-overflow: ellipsis;
}
.ni-tailwind-namespace .text-ellipsis {
  text-overflow: ellipsis;
}
.ni-tailwind-namespace .text-clip {
  text-overflow: clip;
}
.ni-tailwind-namespace .hyphens-none {
  -webkit-hyphens: none;
          hyphens: none;
}
.ni-tailwind-namespace .hyphens-manual {
  -webkit-hyphens: manual;
          hyphens: manual;
}
.ni-tailwind-namespace .hyphens-auto {
  -webkit-hyphens: auto;
          hyphens: auto;
}
.ni-tailwind-namespace .whitespace-normal {
  white-space: normal;
}
.ni-tailwind-namespace .whitespace-nowrap {
  white-space: nowrap;
}
.ni-tailwind-namespace .whitespace-pre {
  white-space: pre;
}
.ni-tailwind-namespace .whitespace-pre-line {
  white-space: pre-line;
}
.ni-tailwind-namespace .whitespace-pre-wrap {
  white-space: pre-wrap;
}
.ni-tailwind-namespace .whitespace-break-spaces {
  white-space: break-spaces;
}
.ni-tailwind-namespace .text-wrap {
  text-wrap: wrap;
}
.ni-tailwind-namespace .text-nowrap {
  text-wrap: nowrap;
}
.ni-tailwind-namespace .text-balance {
  text-wrap: balance;
}
.ni-tailwind-namespace .text-pretty {
  text-wrap: pretty;
}
.ni-tailwind-namespace .break-normal {
  overflow-wrap: normal;
  word-break: normal;
}
.ni-tailwind-namespace .break-words {
  overflow-wrap: break-word;
}
.ni-tailwind-namespace .break-all {
  word-break: break-all;
}
.ni-tailwind-namespace .break-keep {
  word-break: keep-all;
}
.ni-tailwind-namespace .\\!rounded-none {
  border-radius: 0px !important;
}
.ni-tailwind-namespace .rounded {
  border-radius: 0.25rem;
}
.ni-tailwind-namespace .rounded-\\[2px\\] {
  border-radius: 2px;
}
.ni-tailwind-namespace .rounded-full {
  border-radius: 9999px;
}
.ni-tailwind-namespace .rounded-lg {
  border-radius: 0.5rem;
}
.ni-tailwind-namespace .rounded-md {
  border-radius: 0.375rem;
}
.ni-tailwind-namespace .\\!rounded-r-md {
  border-top-right-radius: 0.375rem !important;
  border-bottom-right-radius: 0.375rem !important;
}
.ni-tailwind-namespace .rounded-b {
  border-bottom-right-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
}
.ni-tailwind-namespace .rounded-e {
  border-start-end-radius: 0.25rem;
  border-end-end-radius: 0.25rem;
}
.ni-tailwind-namespace .rounded-l {
  border-top-left-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
}
.ni-tailwind-namespace .rounded-l-lg {
  border-top-left-radius: 0.5rem;
  border-bottom-left-radius: 0.5rem;
}
.ni-tailwind-namespace .rounded-l-md {
  border-top-left-radius: 0.375rem;
  border-bottom-left-radius: 0.375rem;
}
.ni-tailwind-namespace .rounded-l-none {
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
}
.ni-tailwind-namespace .rounded-r {
  border-top-right-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
}
.ni-tailwind-namespace .rounded-r-lg {
  border-top-right-radius: 0.5rem;
  border-bottom-right-radius: 0.5rem;
}
.ni-tailwind-namespace .rounded-r-none {
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
}
.ni-tailwind-namespace .rounded-s {
  border-start-start-radius: 0.25rem;
  border-end-start-radius: 0.25rem;
}
.ni-tailwind-namespace .rounded-t {
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
}
.ni-tailwind-namespace .rounded-bl {
  border-bottom-left-radius: 0.25rem;
}
.ni-tailwind-namespace .rounded-br {
  border-bottom-right-radius: 0.25rem;
}
.ni-tailwind-namespace .rounded-ee {
  border-end-end-radius: 0.25rem;
}
.ni-tailwind-namespace .rounded-es {
  border-end-start-radius: 0.25rem;
}
.ni-tailwind-namespace .rounded-se {
  border-start-end-radius: 0.25rem;
}
.ni-tailwind-namespace .rounded-ss {
  border-start-start-radius: 0.25rem;
}
.ni-tailwind-namespace .rounded-tl {
  border-top-left-radius: 0.25rem;
}
.ni-tailwind-namespace .rounded-tr {
  border-top-right-radius: 0.25rem;
}
.ni-tailwind-namespace .border {
  border-width: 1px;
}
.ni-tailwind-namespace .border-0 {
  border-width: 0px;
}
.ni-tailwind-namespace .border-2 {
  border-width: 2px;
}
.ni-tailwind-namespace .border-x {
  border-left-width: 1px;
  border-right-width: 1px;
}
.ni-tailwind-namespace .border-y {
  border-top-width: 1px;
  border-bottom-width: 1px;
}
.ni-tailwind-namespace .border-b {
  border-bottom-width: 1px;
}
.ni-tailwind-namespace .border-b-2 {
  border-bottom-width: 2px;
}
.ni-tailwind-namespace .border-e {
  border-inline-end-width: 1px;
}
.ni-tailwind-namespace .border-l {
  border-left-width: 1px;
}
.ni-tailwind-namespace .border-l-0 {
  border-left-width: 0px;
}
.ni-tailwind-namespace .border-r {
  border-right-width: 1px;
}
.ni-tailwind-namespace .border-r-0 {
  border-right-width: 0px;
}
.ni-tailwind-namespace .border-r-2 {
  border-right-width: 2px;
}
.ni-tailwind-namespace .border-s {
  border-inline-start-width: 1px;
}
.ni-tailwind-namespace .border-t {
  border-top-width: 1px;
}
.ni-tailwind-namespace .border-solid {
  border-style: solid;
}
.ni-tailwind-namespace .border-dashed {
  border-style: dashed;
}
.ni-tailwind-namespace .border-dotted {
  border-style: dotted;
}
.ni-tailwind-namespace .border-double {
  border-style: double;
}
.ni-tailwind-namespace .border-hidden {
  border-style: hidden;
}
.ni-tailwind-namespace .border-none {
  border-style: none;
}
.ni-tailwind-namespace .\\!border-transparent {
  border-color: transparent !important;
}
.ni-tailwind-namespace .border-current {
  border-color: currentColor;
}
.ni-tailwind-namespace .border-error {
  --tw-border-opacity: 1;
  border-color: rgb(224 61 61 / var(--tw-border-opacity));
}
.ni-tailwind-namespace .border-grey-40 {
  --tw-border-opacity: 1;
  border-color: rgb(220 225 229 / var(--tw-border-opacity));
}
.ni-tailwind-namespace .border-grey-50 {
  --tw-border-opacity: 1;
  border-color: rgb(187 193 199 / var(--tw-border-opacity));
}
.ni-tailwind-namespace .border-grey-60 {
  --tw-border-opacity: 1;
  border-color: rgb(134 142 150 / var(--tw-border-opacity));
}
.ni-tailwind-namespace .border-grey-90 {
  --tw-border-opacity: 1;
  border-color: rgb(22 24 25 / var(--tw-border-opacity));
}
.ni-tailwind-namespace .border-info {
  --tw-border-opacity: 1;
  border-color: rgb(10 123 195 / var(--tw-border-opacity));
}
.ni-tailwind-namespace .border-subscription {
  --tw-border-opacity: 1;
  border-color: rgb(34 112 229 / var(--tw-border-opacity));
}
.ni-tailwind-namespace .border-success {
  --tw-border-opacity: 1;
  border-color: rgb(18 178 98 / var(--tw-border-opacity));
}
.ni-tailwind-namespace .border-transparent {
  border-color: transparent;
}
.ni-tailwind-namespace .border-warning {
  --tw-border-opacity: 1;
  border-color: rgb(242 185 37 / var(--tw-border-opacity));
}
.ni-tailwind-namespace .\\!bg-grey-20 {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(238 240 242 / var(--tw-bg-opacity)) !important;
}
.ni-tailwind-namespace .bg-\\[\\#303030\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(48 48 48 / var(--tw-bg-opacity));
}
.ni-tailwind-namespace .bg-\\[rgb\\(255\\2c 0\\2c 0\\)\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(255 0 0 / var(--tw-bg-opacity));
}
.ni-tailwind-namespace .bg-black {
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity));
}
.ni-tailwind-namespace .bg-error {
  --tw-bg-opacity: 1;
  background-color: rgb(224 61 61 / var(--tw-bg-opacity));
}
.ni-tailwind-namespace .bg-error-dim {
  --tw-bg-opacity: 1;
  background-color: rgb(252 236 236 / var(--tw-bg-opacity));
}
.ni-tailwind-namespace .bg-grey-20 {
  --tw-bg-opacity: 1;
  background-color: rgb(238 240 242 / var(--tw-bg-opacity));
}
.ni-tailwind-namespace .bg-grey-40 {
  --tw-bg-opacity: 1;
  background-color: rgb(220 225 229 / var(--tw-bg-opacity));
}
.ni-tailwind-namespace .bg-grey-90 {
  --tw-bg-opacity: 1;
  background-color: rgb(22 24 25 / var(--tw-bg-opacity));
}
.ni-tailwind-namespace .bg-info {
  --tw-bg-opacity: 1;
  background-color: rgb(10 123 195 / var(--tw-bg-opacity));
}
.ni-tailwind-namespace .bg-info-dim {
  --tw-bg-opacity: 1;
  background-color: rgb(231 242 249 / var(--tw-bg-opacity));
}
.ni-tailwind-namespace .bg-savings {
  --tw-bg-opacity: 1;
  background-color: rgb(18 178 98 / var(--tw-bg-opacity));
}
.ni-tailwind-namespace .bg-subscription {
  --tw-bg-opacity: 1;
  background-color: rgb(34 112 229 / var(--tw-bg-opacity));
}
.ni-tailwind-namespace .bg-success {
  --tw-bg-opacity: 1;
  background-color: rgb(18 178 98 / var(--tw-bg-opacity));
}
.ni-tailwind-namespace .bg-success-dim {
  --tw-bg-opacity: 1;
  background-color: rgb(232 248 240 / var(--tw-bg-opacity));
}
.ni-tailwind-namespace .bg-warning {
  --tw-bg-opacity: 1;
  background-color: rgb(242 185 37 / var(--tw-bg-opacity));
}
.ni-tailwind-namespace .bg-warning-dim {
  --tw-bg-opacity: 1;
  background-color: rgb(254 248 234 / var(--tw-bg-opacity));
}
.ni-tailwind-namespace .bg-white {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}
.ni-tailwind-namespace .bg-opacity-15 {
  --tw-bg-opacity: 0.15;
}
.ni-tailwind-namespace .bg-opacity-80 {
  --tw-bg-opacity: 0.8;
}
.ni-tailwind-namespace .bg-checkmark {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
.ni-tailwind-namespace .decoration-slice {
  -webkit-box-decoration-break: slice;
          box-decoration-break: slice;
}
.ni-tailwind-namespace .decoration-clone {
  -webkit-box-decoration-break: clone;
          box-decoration-break: clone;
}
.ni-tailwind-namespace .box-decoration-slice {
  -webkit-box-decoration-break: slice;
          box-decoration-break: slice;
}
.ni-tailwind-namespace .box-decoration-clone {
  -webkit-box-decoration-break: clone;
          box-decoration-break: clone;
}
.ni-tailwind-namespace .bg-contain {
  background-size: contain;
}
.ni-tailwind-namespace .bg-fixed {
  background-attachment: fixed;
}
.ni-tailwind-namespace .bg-local {
  background-attachment: local;
}
.ni-tailwind-namespace .bg-scroll {
  background-attachment: scroll;
}
.ni-tailwind-namespace .bg-clip-border {
  background-clip: border-box;
}
.ni-tailwind-namespace .bg-clip-padding {
  background-clip: padding-box;
}
.ni-tailwind-namespace .bg-clip-content {
  background-clip: content-box;
}
.ni-tailwind-namespace .bg-clip-text {
  -webkit-background-clip: text;
          background-clip: text;
}
.ni-tailwind-namespace .bg-center {
  background-position: center;
}
.ni-tailwind-namespace .bg-repeat {
  background-repeat: repeat;
}
.ni-tailwind-namespace .bg-no-repeat {
  background-repeat: no-repeat;
}
.ni-tailwind-namespace .bg-repeat-x {
  background-repeat: repeat-x;
}
.ni-tailwind-namespace .bg-repeat-y {
  background-repeat: repeat-y;
}
.ni-tailwind-namespace .bg-repeat-round {
  background-repeat: round;
}
.ni-tailwind-namespace .bg-repeat-space {
  background-repeat: space;
}
.ni-tailwind-namespace .bg-origin-border {
  background-origin: border-box;
}
.ni-tailwind-namespace .bg-origin-padding {
  background-origin: padding-box;
}
.ni-tailwind-namespace .bg-origin-content {
  background-origin: content-box;
}
.ni-tailwind-namespace .fill-current {
  fill: currentColor;
}
.ni-tailwind-namespace .object-contain {
  -o-object-fit: contain;
     object-fit: contain;
}
.ni-tailwind-namespace .object-cover {
  -o-object-fit: cover;
     object-fit: cover;
}
.ni-tailwind-namespace .object-fill {
  -o-object-fit: fill;
     object-fit: fill;
}
.ni-tailwind-namespace .object-none {
  -o-object-fit: none;
     object-fit: none;
}
.ni-tailwind-namespace .object-scale-down {
  -o-object-fit: scale-down;
     object-fit: scale-down;
}
.ni-tailwind-namespace .p-0 {
  padding: 0px;
}
.ni-tailwind-namespace .p-0\\.5 {
  padding: 4px;
}
.ni-tailwind-namespace .p-1 {
  padding: 8px;
}
.ni-tailwind-namespace .p-2 {
  padding: 16px;
}
.ni-tailwind-namespace .p-3 {
  padding: 24px;
}
.ni-tailwind-namespace .p-4 {
  padding: 32px;
}
.ni-tailwind-namespace .p-6 {
  padding: 48px;
}
.ni-tailwind-namespace .px-1 {
  padding-left: 8px;
  padding-right: 8px;
}
.ni-tailwind-namespace .px-2 {
  padding-left: 16px;
  padding-right: 16px;
}
.ni-tailwind-namespace .px-3 {
  padding-left: 24px;
  padding-right: 24px;
}
.ni-tailwind-namespace .px-4 {
  padding-left: 32px;
  padding-right: 32px;
}
.ni-tailwind-namespace .px-5 {
  padding-left: 40px;
  padding-right: 40px;
}
.ni-tailwind-namespace .py-0 {
  padding-top: 0px;
  padding-bottom: 0px;
}
.ni-tailwind-namespace .py-0\\.25 {
  padding-top: 2px;
  padding-bottom: 2px;
}
.ni-tailwind-namespace .py-1 {
  padding-top: 8px;
  padding-bottom: 8px;
}
.ni-tailwind-namespace .py-1\\.25 {
  padding-top: 10px;
  padding-bottom: 10px;
}
.ni-tailwind-namespace .py-2 {
  padding-top: 16px;
  padding-bottom: 16px;
}
.ni-tailwind-namespace .py-3 {
  padding-top: 24px;
  padding-bottom: 24px;
}
.ni-tailwind-namespace .py-4 {
  padding-top: 32px;
  padding-bottom: 32px;
}
.ni-tailwind-namespace .py-5 {
  padding-top: 40px;
  padding-bottom: 40px;
}
.ni-tailwind-namespace .py-6 {
  padding-top: 48px;
  padding-bottom: 48px;
}
.ni-tailwind-namespace .py-\\[1px\\] {
  padding-top: 1px;
  padding-bottom: 1px;
}
.ni-tailwind-namespace .pb-0 {
  padding-bottom: 0px;
}
.ni-tailwind-namespace .pb-0\\.5 {
  padding-bottom: 4px;
}
.ni-tailwind-namespace .pb-1 {
  padding-bottom: 8px;
}
.ni-tailwind-namespace .pb-1\\.5 {
  padding-bottom: 12px;
}
.ni-tailwind-namespace .pb-2 {
  padding-bottom: 16px;
}
.ni-tailwind-namespace .pb-3 {
  padding-bottom: 24px;
}
.ni-tailwind-namespace .pb-4 {
  padding-bottom: 32px;
}
.ni-tailwind-namespace .pl-0 {
  padding-left: 0px;
}
.ni-tailwind-namespace .pl-1 {
  padding-left: 8px;
}
.ni-tailwind-namespace .pl-2 {
  padding-left: 16px;
}
.ni-tailwind-namespace .pl-3 {
  padding-left: 24px;
}
.ni-tailwind-namespace .pr-1 {
  padding-right: 8px;
}
.ni-tailwind-namespace .pr-2 {
  padding-right: 16px;
}
.ni-tailwind-namespace .pt-2 {
  padding-top: 16px;
}
.ni-tailwind-namespace .pt-2\\.5 {
  padding-top: 20px;
}
.ni-tailwind-namespace .pt-3 {
  padding-top: 24px;
}
.ni-tailwind-namespace .pt-4 {
  padding-top: 32px;
}
.ni-tailwind-namespace .text-left {
  text-align: left;
}
.ni-tailwind-namespace .text-center {
  text-align: center;
}
.ni-tailwind-namespace .text-right {
  text-align: right;
}
.ni-tailwind-namespace .text-justify {
  text-align: justify;
}
.ni-tailwind-namespace .text-start {
  text-align: start;
}
.ni-tailwind-namespace .text-end {
  text-align: end;
}
.ni-tailwind-namespace .align-baseline {
  vertical-align: baseline;
}
.ni-tailwind-namespace .align-top {
  vertical-align: top;
}
.ni-tailwind-namespace .align-middle {
  vertical-align: middle;
}
.ni-tailwind-namespace .align-bottom {
  vertical-align: bottom;
}
.ni-tailwind-namespace .align-text-top {
  vertical-align: text-top;
}
.ni-tailwind-namespace .align-text-bottom {
  vertical-align: text-bottom;
}
.ni-tailwind-namespace .align-sub {
  vertical-align: sub;
}
.ni-tailwind-namespace .align-super {
  vertical-align: super;
}
.ni-tailwind-namespace .font-bold {
  font-weight: 600;
}
.ni-tailwind-namespace .font-medium {
  font-weight: 500;
}
.ni-tailwind-namespace .font-regular {
  font-weight: 400;
}
.ni-tailwind-namespace .uppercase {
  text-transform: uppercase;
}
.ni-tailwind-namespace .lowercase {
  text-transform: lowercase;
}
.ni-tailwind-namespace .capitalize {
  text-transform: capitalize;
}
.ni-tailwind-namespace .normal-case {
  text-transform: none;
}
.ni-tailwind-namespace .italic {
  font-style: italic;
}
.ni-tailwind-namespace .not-italic {
  font-style: normal;
}
.ni-tailwind-namespace .normal-nums {
  font-variant-numeric: normal;
}
.ni-tailwind-namespace .ordinal {
  --tw-ordinal: ordinal;
  font-variant-numeric: var(--tw-ordinal) var(--tw-slashed-zero) var(--tw-numeric-figure) var(--tw-numeric-spacing) var(--tw-numeric-fraction);
}
.ni-tailwind-namespace .slashed-zero {
  --tw-slashed-zero: slashed-zero;
  font-variant-numeric: var(--tw-ordinal) var(--tw-slashed-zero) var(--tw-numeric-figure) var(--tw-numeric-spacing) var(--tw-numeric-fraction);
}
.ni-tailwind-namespace .lining-nums {
  --tw-numeric-figure: lining-nums;
  font-variant-numeric: var(--tw-ordinal) var(--tw-slashed-zero) var(--tw-numeric-figure) var(--tw-numeric-spacing) var(--tw-numeric-fraction);
}
.ni-tailwind-namespace .oldstyle-nums {
  --tw-numeric-figure: oldstyle-nums;
  font-variant-numeric: var(--tw-ordinal) var(--tw-slashed-zero) var(--tw-numeric-figure) var(--tw-numeric-spacing) var(--tw-numeric-fraction);
}
.ni-tailwind-namespace .proportional-nums {
  --tw-numeric-spacing: proportional-nums;
  font-variant-numeric: var(--tw-ordinal) var(--tw-slashed-zero) var(--tw-numeric-figure) var(--tw-numeric-spacing) var(--tw-numeric-fraction);
}
.ni-tailwind-namespace .tabular-nums {
  --tw-numeric-spacing: tabular-nums;
  font-variant-numeric: var(--tw-ordinal) var(--tw-slashed-zero) var(--tw-numeric-figure) var(--tw-numeric-spacing) var(--tw-numeric-fraction);
}
.ni-tailwind-namespace .diagonal-fractions {
  --tw-numeric-fraction: diagonal-fractions;
  font-variant-numeric: var(--tw-ordinal) var(--tw-slashed-zero) var(--tw-numeric-figure) var(--tw-numeric-spacing) var(--tw-numeric-fraction);
}
.ni-tailwind-namespace .stacked-fractions {
  --tw-numeric-fraction: stacked-fractions;
  font-variant-numeric: var(--tw-ordinal) var(--tw-slashed-zero) var(--tw-numeric-figure) var(--tw-numeric-spacing) var(--tw-numeric-fraction);
}
.ni-tailwind-namespace .\\!text-grey-90 {
  --tw-text-opacity: 1 !important;
  color: rgb(22 24 25 / var(--tw-text-opacity)) !important;
}
.ni-tailwind-namespace .text-\\[\\#336699\\]\\/\\[\\.35\\] {
  color: rgb(51 102 153 / .35);
}
.ni-tailwind-namespace .text-black {
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity));
}
.ni-tailwind-namespace .text-current {
  color: currentColor;
}
.ni-tailwind-namespace .text-error {
  --tw-text-opacity: 1;
  color: rgb(224 61 61 / var(--tw-text-opacity));
}
.ni-tailwind-namespace .text-grey-50 {
  --tw-text-opacity: 1;
  color: rgb(187 193 199 / var(--tw-text-opacity));
}
.ni-tailwind-namespace .text-grey-60 {
  --tw-text-opacity: 1;
  color: rgb(134 142 150 / var(--tw-text-opacity));
}
.ni-tailwind-namespace .text-grey-70 {
  --tw-text-opacity: 1;
  color: rgb(73 80 87 / var(--tw-text-opacity));
}
.ni-tailwind-namespace .text-grey-90 {
  --tw-text-opacity: 1;
  color: rgb(22 24 25 / var(--tw-text-opacity));
}
.ni-tailwind-namespace .text-info {
  --tw-text-opacity: 1;
  color: rgb(10 123 195 / var(--tw-text-opacity));
}
.ni-tailwind-namespace .text-savings {
  --tw-text-opacity: 1;
  color: rgb(18 178 98 / var(--tw-text-opacity));
}
.ni-tailwind-namespace .text-success {
  --tw-text-opacity: 1;
  color: rgb(18 178 98 / var(--tw-text-opacity));
}
.ni-tailwind-namespace .text-warning {
  --tw-text-opacity: 1;
  color: rgb(242 185 37 / var(--tw-text-opacity));
}
.ni-tailwind-namespace .text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
.ni-tailwind-namespace .underline {
  text-decoration-line: underline;
}
.ni-tailwind-namespace .overline {
  text-decoration-line: overline;
}
.ni-tailwind-namespace .line-through {
  text-decoration-line: line-through;
}
.ni-tailwind-namespace .no-underline {
  text-decoration-line: none;
}
.ni-tailwind-namespace .decoration-solid {
  text-decoration-style: solid;
}
.ni-tailwind-namespace .decoration-double {
  text-decoration-style: double;
}
.ni-tailwind-namespace .decoration-dotted {
  text-decoration-style: dotted;
}
.ni-tailwind-namespace .decoration-dashed {
  text-decoration-style: dashed;
}
.ni-tailwind-namespace .decoration-wavy {
  text-decoration-style: wavy;
}
.ni-tailwind-namespace .antialiased {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.ni-tailwind-namespace .subpixel-antialiased {
  -webkit-font-smoothing: auto;
  -moz-osx-font-smoothing: auto;
}
.ni-tailwind-namespace .placeholder-grey-60::-moz-placeholder {
  --tw-placeholder-opacity: 1;
  color: rgb(134 142 150 / var(--tw-placeholder-opacity));
}
.ni-tailwind-namespace .placeholder-grey-60::placeholder {
  --tw-placeholder-opacity: 1;
  color: rgb(134 142 150 / var(--tw-placeholder-opacity));
}
.ni-tailwind-namespace .opacity-0 {
  opacity: 0;
}
.ni-tailwind-namespace .opacity-100 {
  opacity: 1;
}
.ni-tailwind-namespace .opacity-70 {
  opacity: 0.7;
}
.ni-tailwind-namespace .opacity-\\[0\\.15\\] {
  opacity: 0.15;
}
.ni-tailwind-namespace .bg-blend-normal {
  background-blend-mode: normal;
}
.ni-tailwind-namespace .bg-blend-multiply {
  background-blend-mode: multiply;
}
.ni-tailwind-namespace .bg-blend-screen {
  background-blend-mode: screen;
}
.ni-tailwind-namespace .bg-blend-overlay {
  background-blend-mode: overlay;
}
.ni-tailwind-namespace .bg-blend-darken {
  background-blend-mode: darken;
}
.ni-tailwind-namespace .bg-blend-lighten {
  background-blend-mode: lighten;
}
.ni-tailwind-namespace .bg-blend-color-dodge {
  background-blend-mode: color-dodge;
}
.ni-tailwind-namespace .bg-blend-color-burn {
  background-blend-mode: color-burn;
}
.ni-tailwind-namespace .bg-blend-hard-light {
  background-blend-mode: hard-light;
}
.ni-tailwind-namespace .bg-blend-soft-light {
  background-blend-mode: soft-light;
}
.ni-tailwind-namespace .bg-blend-difference {
  background-blend-mode: difference;
}
.ni-tailwind-namespace .bg-blend-exclusion {
  background-blend-mode: exclusion;
}
.ni-tailwind-namespace .bg-blend-hue {
  background-blend-mode: hue;
}
.ni-tailwind-namespace .bg-blend-saturation {
  background-blend-mode: saturation;
}
.ni-tailwind-namespace .bg-blend-color {
  background-blend-mode: color;
}
.ni-tailwind-namespace .bg-blend-luminosity {
  background-blend-mode: luminosity;
}
.ni-tailwind-namespace .mix-blend-normal {
  mix-blend-mode: normal;
}
.ni-tailwind-namespace .mix-blend-multiply {
  mix-blend-mode: multiply;
}
.ni-tailwind-namespace .mix-blend-screen {
  mix-blend-mode: screen;
}
.ni-tailwind-namespace .mix-blend-overlay {
  mix-blend-mode: overlay;
}
.ni-tailwind-namespace .mix-blend-darken {
  mix-blend-mode: darken;
}
.ni-tailwind-namespace .mix-blend-lighten {
  mix-blend-mode: lighten;
}
.ni-tailwind-namespace .mix-blend-color-dodge {
  mix-blend-mode: color-dodge;
}
.ni-tailwind-namespace .mix-blend-color-burn {
  mix-blend-mode: color-burn;
}
.ni-tailwind-namespace .mix-blend-hard-light {
  mix-blend-mode: hard-light;
}
.ni-tailwind-namespace .mix-blend-soft-light {
  mix-blend-mode: soft-light;
}
.ni-tailwind-namespace .mix-blend-difference {
  mix-blend-mode: difference;
}
.ni-tailwind-namespace .mix-blend-exclusion {
  mix-blend-mode: exclusion;
}
.ni-tailwind-namespace .mix-blend-hue {
  mix-blend-mode: hue;
}
.ni-tailwind-namespace .mix-blend-saturation {
  mix-blend-mode: saturation;
}
.ni-tailwind-namespace .mix-blend-color {
  mix-blend-mode: color;
}
.ni-tailwind-namespace .mix-blend-luminosity {
  mix-blend-mode: luminosity;
}
.ni-tailwind-namespace .mix-blend-plus-lighter {
  mix-blend-mode: plus-lighter;
}
.ni-tailwind-namespace .\\!shadow {
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1) !important;
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color) !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}
.ni-tailwind-namespace .shadow {
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.ni-tailwind-namespace .shadow-sm {
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.ni-tailwind-namespace .shadow-xl {
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.ni-tailwind-namespace .shadow-grey-50 {
  --tw-shadow-color: #BBC1C7;
  --tw-shadow: var(--tw-shadow-colored);
}
.ni-tailwind-namespace .outline-none {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.ni-tailwind-namespace .\\!outline {
  outline-style: solid !important;
}
.ni-tailwind-namespace .outline {
  outline-style: solid;
}
.ni-tailwind-namespace .outline-dashed {
  outline-style: dashed;
}
.ni-tailwind-namespace .outline-dotted {
  outline-style: dotted;
}
.ni-tailwind-namespace .outline-double {
  outline-style: double;
}
.ni-tailwind-namespace .outline-2 {
  outline-width: 2px;
}
.ni-tailwind-namespace .outline-grey-90 {
  outline-color: #161819;
}
.ni-tailwind-namespace .ring {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ni-tailwind-namespace .ring-inset {
  --tw-ring-inset: inset;
}
.ni-tailwind-namespace .blur {
  --tw-blur: blur(8px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.ni-tailwind-namespace .drop-shadow {
  --tw-drop-shadow: drop-shadow(0 1px 2px rgb(0 0 0 / 0.1)) drop-shadow(0 1px 1px rgb(0 0 0 / 0.06));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.ni-tailwind-namespace .grayscale {
  --tw-grayscale: grayscale(100%);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.ni-tailwind-namespace .invert {
  --tw-invert: invert(100%);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.ni-tailwind-namespace .sepia {
  --tw-sepia: sepia(100%);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.ni-tailwind-namespace .\\!filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow) !important;
}
.ni-tailwind-namespace .filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.ni-tailwind-namespace .filter-none {
  filter: none;
}
.ni-tailwind-namespace .backdrop-blur {
  --tw-backdrop-blur: blur(8px);
  -webkit-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
          backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.ni-tailwind-namespace .backdrop-grayscale {
  --tw-backdrop-grayscale: grayscale(100%);
  -webkit-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
          backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.ni-tailwind-namespace .backdrop-invert {
  --tw-backdrop-invert: invert(100%);
  -webkit-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
          backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.ni-tailwind-namespace .backdrop-sepia {
  --tw-backdrop-sepia: sepia(100%);
  -webkit-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
          backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.ni-tailwind-namespace .backdrop-filter {
  -webkit-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
          backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.ni-tailwind-namespace .backdrop-filter-none {
  -webkit-backdrop-filter: none;
          backdrop-filter: none;
}
.ni-tailwind-namespace .\\!transition {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter !important;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter !important;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter !important;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
  transition-duration: 150ms !important;
}
.ni-tailwind-namespace .transition {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.ni-tailwind-namespace .transition-\\[fill\\] {
  transition-property: fill;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.ni-tailwind-namespace .transition-\\[transform\\] {
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.ni-tailwind-namespace .transition-all {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.ni-tailwind-namespace .transition-bg {
  transition-property: background;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.ni-tailwind-namespace .transition-colors {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.ni-tailwind-namespace .transition-opacity {
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.ni-tailwind-namespace .duration-150 {
  transition-duration: 150ms;
}
.ni-tailwind-namespace .duration-300 {
  transition-duration: 300ms;
}
.ni-tailwind-namespace .duration-\\[0\\.15s\\] {
  transition-duration: 0.15s;
}
.ni-tailwind-namespace .duration-\\[0\\.25s\\] {
  transition-duration: 0.25s;
}
.ni-tailwind-namespace .ease-in {
  transition-timing-function: cubic-bezier(0.4, 0, 1, 1);
}
.ni-tailwind-namespace .ease-in-out {
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
.ni-tailwind-namespace .ease-out {
  transition-timing-function: cubic-bezier(0.33, 1, 0.68, 1);
}
.ni-tailwind-namespace .content-\\[\\'this-is-also-valid\\]-weirdly-enough\\'\\] {
  --tw-content: 'this-is-also-valid]-weirdly-enough';
  content: var(--tw-content);
}
.ni-tailwind-namespace .forced-color-adjust-auto {
  forced-color-adjust: auto;
}
.ni-tailwind-namespace .forced-color-adjust-none {
  forced-color-adjust: none;
}
.ni-tailwind-namespace .\\[a-zA-Z0-9\\:\\\\\\\\-\\\\\\\\\\._\\\$\\] {
  a-z-a--z0-9: \\\\-\\\\. \$;
}
@font-face {
  font-family: "NativePro";
  font-style: normal;
  font-display: swap;
  font-weight: 600;
  src:
    url("https://storage.googleapis.com/ni-assets/assets/fonts/NATIVEPro-600600.woff2") format("woff2"),
    url("https://storage.googleapis.com/ni-assets/assets/fonts/NATIVEPro-600600.woff") format("woff");
}
@font-face {
  font-family: "Graphik";
  font-style: normal;
  font-display: swap;
  font-weight: 400;
  src:
    url("https://storage.googleapis.com/ni-assets/assets/fonts/Graphik-Regular-Web.woff2")
      format("woff2"),
    url("https://storage.googleapis.com/ni-assets/assets/fonts/Graphik-Regular-Web.woff")
      format("woff");
}
@font-face {
  font-family: "Graphik";
  font-style: italic;
  font-display: swap;
  font-weight: 400;
  src:
    url("https://storage.googleapis.com/ni-assets/assets/fonts/Graphik-RegularItalic-Web.woff2")
      format("woff2"),
    url("https://storage.googleapis.com/ni-assets/assets/fonts/Graphik-RegularItalic-Web.woff")
      format("woff");
}
@font-face {
  font-family: "Graphik";
  font-style: normal;
  font-display: swap;
  font-weight: 500;
  src:
    url("https://storage.googleapis.com/ni-assets/assets/fonts/Graphik-Medium-Web.woff2")
      format("woff2"),
    url("https://storage.googleapis.com/ni-assets/assets/fonts/Graphik-Medium-Web.woff")
      format("woff");
}
@font-face {
  font-family: "Graphik";
  font-style: italic;
  font-display: swap;
  font-weight: 500;
  src:
    url("https://storage.googleapis.com/ni-assets/assets/fonts/Graphik-MediumItalic-Web.woff2")
      format("woff2"),
    url("https://storage.googleapis.com/ni-assets/assets/fonts/Graphik-MediumItalic-Web.woff")
      format("woff");
}
@font-face {
  font-family: "Graphik";
  font-style: normal;
  font-display: swap;
  font-weight: 600;
  src:
    url("https://storage.googleapis.com/ni-assets/assets/fonts/Graphik-Semibold-Web.woff2")
      format("woff2"),
    url("https://storage.googleapis.com/ni-assets/assets/fonts/Graphik-Semibold-Web.woff")
      format("woff");
}
@font-face {
  font-family: "Graphik";
  font-style: italic;
  font-display: swap;
  font-weight: 600;
  src:
    url("https://storage.googleapis.com/ni-assets/assets/fonts/Graphik-SemiboldItalic-Web.woff2")
      format("woff2"),
    url("https://storage.googleapis.com/ni-assets/assets/fonts/Graphik-SemiboldItalic-Web.woff")
      format("woff");
}
@media (min-width: 375px) {

  .ni-tailwind-namespace .sm\\:container {
    margin-left: 24px;
    margin-right: 24px;
  }

  @media (min-width: 768px) {

    .ni-tailwind-namespace .sm\\:container {
      margin-left: 40px;
      margin-right: 40px;
    }
  }

  @media (min-width: 1024px) {

    .ni-tailwind-namespace .sm\\:container {
      margin-left: auto;
      margin-right: auto;
      max-width: 912px;
    }
  }

  @media (min-width: 1280px) {

    .ni-tailwind-namespace .sm\\:container {
      max-width: 1104px;
    }
  }

  @media (min-width: 1920px) {

    .ni-tailwind-namespace .sm\\:container {
      max-width: 1472px;
    }
  }
}
.ni-tailwind-namespace .placeholder\\:italic::-moz-placeholder {
  font-style: italic;
}
.ni-tailwind-namespace .placeholder\\:italic::placeholder {
  font-style: italic;
}
.ni-tailwind-namespace .after\\:block::after {
  content: var(--tw-content);
  display: block;
}
.ni-tailwind-namespace .after\\:size-\\[10px\\]::after {
  content: var(--tw-content);
  width: 10px;
  height: 10px;
}
.ni-tailwind-namespace .after\\:rounded-full::after {
  content: var(--tw-content);
  border-radius: 9999px;
}
.ni-tailwind-namespace .after\\:bg-grey-90::after {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(22 24 25 / var(--tw-bg-opacity));
}
.ni-tailwind-namespace .after\\:content-\\[\\'\\'\\]::after {
  --tw-content: '';
  content: var(--tw-content);
}
.ni-tailwind-namespace .last\\:mr-0:last-child {
  margin-right: 0px;
}
.ni-tailwind-namespace .checked\\:border-grey-90:checked {
  --tw-border-opacity: 1;
  border-color: rgb(22 24 25 / var(--tw-border-opacity));
}
.ni-tailwind-namespace .hover\\:border-error:hover {
  --tw-border-opacity: 1;
  border-color: rgb(224 61 61 / var(--tw-border-opacity));
}
.ni-tailwind-namespace .hover\\:border-grey-40:hover {
  --tw-border-opacity: 1;
  border-color: rgb(220 225 229 / var(--tw-border-opacity));
}
.ni-tailwind-namespace .hover\\:border-grey-50:hover {
  --tw-border-opacity: 1;
  border-color: rgb(187 193 199 / var(--tw-border-opacity));
}
.ni-tailwind-namespace .hover\\:border-grey-60:hover {
  --tw-border-opacity: 1;
  border-color: rgb(134 142 150 / var(--tw-border-opacity));
}
.ni-tailwind-namespace .hover\\:border-grey-70:hover {
  --tw-border-opacity: 1;
  border-color: rgb(73 80 87 / var(--tw-border-opacity));
}
.ni-tailwind-namespace .hover\\:border-subscription:hover {
  --tw-border-opacity: 1;
  border-color: rgb(34 112 229 / var(--tw-border-opacity));
}
.ni-tailwind-namespace .hover\\:font-bold:hover {
  font-weight: 600;
}
.ni-tailwind-namespace .hover\\:underline:hover {
  text-decoration-line: underline;
}
.ni-tailwind-namespace .before\\:hover\\:text-center:hover::before {
  content: var(--tw-content);
  text-align: center;
}
.ni-tailwind-namespace .hover\\:before\\:text-center:hover::before {
  content: var(--tw-content);
  text-align: center;
}
.ni-tailwind-namespace .focus\\:border-grey-90:focus {
  --tw-border-opacity: 1;
  border-color: rgb(22 24 25 / var(--tw-border-opacity));
}
.ni-tailwind-namespace .focus\\:outline-none:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.ni-tailwind-namespace .focus\\:hover\\:text-center:hover:focus {
  text-align: center;
}
.ni-tailwind-namespace .hover\\:focus\\:text-center:focus:hover {
  text-align: center;
}
.ni-tailwind-namespace .disabled\\:bg-grey-20:disabled {
  --tw-bg-opacity: 1;
  background-color: rgb(238 240 242 / var(--tw-bg-opacity));
}
.ni-tailwind-namespace .group:hover .group-hover\\:bg-grey-20 {
  --tw-bg-opacity: 1;
  background-color: rgb(238 240 242 / var(--tw-bg-opacity));
}
.ni-tailwind-namespace .group:focus-visible .group-focus-visible\\:\\!border-transparent {
  border-color: transparent !important;
}
.ni-tailwind-namespace .group:focus-visible .group-focus-visible\\:outline {
  outline-style: solid;
}
.ni-tailwind-namespace .group:focus-visible .group-focus-visible\\:outline-2 {
  outline-width: 2px;
}
.ni-tailwind-namespace .group:focus-visible .group-focus-visible\\:outline-grey-90 {
  outline-color: #161819;
}
.ni-tailwind-namespace .group:disabled .group-disabled\\:cursor-auto {
  cursor: auto;
}
.ni-tailwind-namespace .group:disabled:hover .group-disabled\\:group-hover\\:bg-white {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}
.ni-tailwind-namespace .peer:-moz-placeholder-shown ~ .peer-placeholder-shown\\:-translate-y-1 {
  --tw-translate-y: -8px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.ni-tailwind-namespace .peer:placeholder-shown ~ .peer-placeholder-shown\\:-translate-y-1 {
  --tw-translate-y: -8px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.ni-tailwind-namespace .peer:-moz-placeholder-shown ~ .peer-placeholder-shown\\:-translate-y-1\\.25 {
  --tw-translate-y: -10px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.ni-tailwind-namespace .peer:placeholder-shown ~ .peer-placeholder-shown\\:-translate-y-1\\.25 {
  --tw-translate-y: -10px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.ni-tailwind-namespace .peer:-moz-placeholder-shown ~ .peer-placeholder-shown\\:translate-y-2 {
  --tw-translate-y: 16px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.ni-tailwind-namespace .peer:placeholder-shown ~ .peer-placeholder-shown\\:translate-y-2 {
  --tw-translate-y: 16px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.ni-tailwind-namespace .peer:-moz-placeholder-shown ~ .peer-placeholder-shown\\:translate-y-2\\.5 {
  --tw-translate-y: 20px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.ni-tailwind-namespace .peer:placeholder-shown ~ .peer-placeholder-shown\\:translate-y-2\\.5 {
  --tw-translate-y: 20px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.ni-tailwind-namespace .peer:-moz-placeholder-shown ~ .peer-placeholder-shown\\:scale-100 {
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.ni-tailwind-namespace .peer:placeholder-shown ~ .peer-placeholder-shown\\:scale-100 {
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.ni-tailwind-namespace .peer:focus ~ .peer-focus\\:-translate-y-1 {
  --tw-translate-y: -8px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.ni-tailwind-namespace .peer:focus ~ .peer-focus\\:-translate-y-1\\.5 {
  --tw-translate-y: -12px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.ni-tailwind-namespace .peer:focus ~ .peer-focus\\:-translate-y-2 {
  --tw-translate-y: -16px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.ni-tailwind-namespace .peer:focus ~ .peer-focus\\:-translate-y-2\\.5 {
  --tw-translate-y: -20px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.ni-tailwind-namespace .peer:focus ~ .peer-focus\\:scale-75 {
  --tw-scale-x: .75;
  --tw-scale-y: .75;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@media (min-width: 375px) {

  .ni-tailwind-namespace .sm\\:translate-y-0 {
    --tw-translate-y: 0px;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }

  .ni-tailwind-namespace .sm\\:scale-100 {
    --tw-scale-x: 1;
    --tw-scale-y: 1;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }

  .ni-tailwind-namespace .sm\\:scale-95 {
    --tw-scale-x: .95;
    --tw-scale-y: .95;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }

  .ni-tailwind-namespace .sm\\:underline {
    text-decoration-line: underline;
  }
}
@media (min-width: 768px) {

  .ni-tailwind-namespace .md\\:visible {
    visibility: visible;
  }

  .ni-tailwind-namespace .md\\:col-span-2 {
    grid-column: span 2 / span 2;
  }

  .ni-tailwind-namespace .md\\:col-span-3 {
    grid-column: span 3 / span 3;
  }

  .ni-tailwind-namespace .md\\:ml-2 {
    margin-left: 16px;
  }

  .ni-tailwind-namespace .md\\:mr-2 {
    margin-right: 16px;
  }

  .ni-tailwind-namespace .md\\:block {
    display: block;
  }

  .ni-tailwind-namespace .md\\:max-h-\\[90vh\\] {
    max-height: 90vh;
  }

  .ni-tailwind-namespace .md\\:flex-row {
    flex-direction: row;
  }

  .ni-tailwind-namespace .md\\:flex-nowrap {
    flex-wrap: nowrap;
  }

  .ni-tailwind-namespace .md\\:place-content-end {
    place-content: end;
  }

  .ni-tailwind-namespace .md\\:space-x-2 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-x-reverse: 0;
    margin-right: calc(16px * var(--tw-space-x-reverse));
    margin-left: calc(16px * calc(1 - var(--tw-space-x-reverse)));
  }

  .ni-tailwind-namespace .md\\:space-y-0 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(0px * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(0px * var(--tw-space-y-reverse));
  }

  .ni-tailwind-namespace .md\\:overflow-y-auto {
    overflow-y: auto;
  }

  .ni-tailwind-namespace .md\\:p-3 {
    padding: 24px;
  }

  .ni-tailwind-namespace .md\\:pl-2 {
    padding-left: 16px;
  }

  .ni-tailwind-namespace .md\\:pt-0 {
    padding-top: 0px;
  }
}
@media (min-width: 1024px) {

  .ni-tailwind-namespace .lg\\:top-1\\/2 {
    top: 50%;
  }

  .ni-tailwind-namespace .lg\\:col-span-4 {
    grid-column: span 4 / span 4;
  }

  .ni-tailwind-namespace .lg\\:col-span-6 {
    grid-column: span 6 / span 6;
  }

  .ni-tailwind-namespace .lg\\:col-span-8 {
    grid-column: span 8 / span 8;
  }

  .ni-tailwind-namespace .lg\\:col-start-1 {
    grid-column-start: 1;
  }

  .ni-tailwind-namespace .lg\\:col-start-2 {
    grid-column-start: 2;
  }

  .ni-tailwind-namespace .lg\\:mb-0 {
    margin-bottom: 0px;
  }

  .ni-tailwind-namespace .lg\\:mb-3 {
    margin-bottom: 24px;
  }

  .ni-tailwind-namespace .lg\\:mb-4 {
    margin-bottom: 32px;
  }

  .ni-tailwind-namespace .lg\\:ml-0 {
    margin-left: 0px;
  }

  .ni-tailwind-namespace .lg\\:ml-0\\.5 {
    margin-left: 4px;
  }

  .ni-tailwind-namespace .lg\\:ml-4 {
    margin-left: 32px;
  }

  .ni-tailwind-namespace .lg\\:mr-0 {
    margin-right: 0px;
  }

  .ni-tailwind-namespace .lg\\:mr-0\\.5 {
    margin-right: 4px;
  }

  .ni-tailwind-namespace .lg\\:mr-4 {
    margin-right: 32px;
  }

  .ni-tailwind-namespace .lg\\:mt-0 {
    margin-top: 0px;
  }

  .ni-tailwind-namespace .lg\\:mt-1 {
    margin-top: 8px;
  }

  .ni-tailwind-namespace .lg\\:inline-block {
    display: inline-block;
  }

  .ni-tailwind-namespace .lg\\:flex {
    display: flex;
  }

  .ni-tailwind-namespace .lg\\:grow {
    flex-grow: 1;
  }

  .ni-tailwind-namespace .lg\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .ni-tailwind-namespace .lg\\:grid-cols-8 {
    grid-template-columns: repeat(8, minmax(0, 1fr));
  }

  .ni-tailwind-namespace .lg\\:flex-row {
    flex-direction: row;
  }

  .ni-tailwind-namespace .lg\\:flex-wrap {
    flex-wrap: wrap;
  }

  .ni-tailwind-namespace .lg\\:gap-4 {
    gap: 32px;
  }

  .ni-tailwind-namespace :is(theme-dark .dark\\:lg\\:hover\\:\\[paint-order\\:markers\\]:hover) {
    paint-order: markers;
  }
}
@media (min-width: 1280px) {

  .ni-tailwind-namespace .xl\\:col-span-10 {
    grid-column: span 10 / span 10;
  }

  .ni-tailwind-namespace .xl\\:col-span-12 {
    grid-column: span 12 / span 12;
  }

  .ni-tailwind-namespace .xl\\:col-span-6 {
    grid-column: span 6 / span 6;
  }

  .ni-tailwind-namespace .xl\\:col-span-8 {
    grid-column: span 8 / span 8;
  }

  .ni-tailwind-namespace .xl\\:col-start-1 {
    grid-column-start: 1;
  }

  .ni-tailwind-namespace .xl\\:col-start-2 {
    grid-column-start: 2;
  }

  .ni-tailwind-namespace .xl\\:col-start-3 {
    grid-column-start: 3;
  }

  .ni-tailwind-namespace .xl\\:mb-18 {
    margin-bottom: 144px;
  }

  .ni-tailwind-namespace .xl\\:mt-0 {
    margin-top: 0px;
  }

  .ni-tailwind-namespace .xl\\:mt-6 {
    margin-top: 48px;
  }

  .ni-tailwind-namespace .xl\\:grid-cols-12 {
    grid-template-columns: repeat(12, minmax(0, 1fr));
  }

  .ni-tailwind-namespace .xl\\:p-8 {
    padding: 64px;
  }

  .ni-tailwind-namespace .xl\\:pb-6 {
    padding-bottom: 48px;
  }
}
@media (min-width: 1920px) {

  .ni-tailwind-namespace .\\32xl\\:col-span-10 {
    grid-column: span 10 / span 10;
  }

  .ni-tailwind-namespace .\\32xl\\:col-span-12 {
    grid-column: span 12 / span 12;
  }

  .ni-tailwind-namespace .\\32xl\\:col-span-5 {
    grid-column: span 5 / span 5;
  }

  .ni-tailwind-namespace .\\32xl\\:col-span-6 {
    grid-column: span 6 / span 6;
  }

  .ni-tailwind-namespace .\\32xl\\:col-span-8 {
    grid-column: span 8 / span 8;
  }

  .ni-tailwind-namespace .\\32xl\\:col-start-1 {
    grid-column-start: 1;
  }

  .ni-tailwind-namespace .\\32xl\\:col-start-2 {
    grid-column-start: 2;
  }

  .ni-tailwind-namespace .\\32xl\\:col-start-3 {
    grid-column-start: 3;
  }

  .ni-tailwind-namespace .\\32xl\\:col-start-4 {
    grid-column-start: 4;
  }
}
`, "",{"version":3,"sources":["webpack://./../../node_modules/.pnpm/tailwindcss@3.4.1/node_modules/tailwindcss/base.css","webpack://./../../packages/webex-ni/dist/css/typography.css","webpack://./../../packages/webex-ni/dist/css/components.css","webpack://./../../node_modules/.pnpm/tailwindcss@3.4.1/node_modules/tailwindcss/utilities.css","webpack://./src/main.css"],"names":[],"mappings":"AAAA;;CAAc,CAAd;;;CAAc;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,0BAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,gBAAc;AAAA;;AAAd;;;;;;;;CAAc;;AAAd;;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gBAAc,EAAd,MAAc;EAAd,cAAc;KAAd,WAAc,EAAd,MAAc;EAAd,+HAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,wCAAc,EAAd,MAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,yCAAc;UAAd,iCAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,mBAAc;AAAA;;AAAd;;;;;CAAc;;AAAd;;;;EAAA,+GAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;AAAd;EAAA,eAAc;AAAA;;AAAd;EAAA,WAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,oBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,YAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,kBAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;AAAd;EAAA,UAAc;AAAA;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,eAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;;AAAd,wEAAc;AAAd;EAAA,aAAc;AAAA;EAAd;EAAA,kDAAc;EAAd,mCAAc;EAAd,kCAAc;;IAAd,eAAc,EAAd,2BAAc;IAAd;AAAc;;EAAd;EAAA;AAAc;;EAAd;EAAA,kBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd;AAAc;ACmFZ;IACE,kBAAkB;IAClB,gBAAgB;EAClB;AAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;AAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;AAEA;IACE,eAAe;IACf,gBAAgB;EAClB;AAEA;IACE,mBAAmB;IACnB,gBAAgB;EAClB;AAEA;IACE,mBAAmB;IACnB,gBAAgB;EAClB;AAEA;IACE;MACE,mBAAmB;IACrB;EACF;AAwCE;IAAA,mBAAyB;IAAzB,gBAAyB;EAAA;AAAzB;IAAA;MAAA,mBAAyB;IAAA;EAAA;AAAzB;EAAA;AAAyB;AAIzB;IAAA,mBAAyB;IAAzB,gBAAyB;EAAA;AAAzB;IAAA;MAAA,mBAAyB;IAAA;EAAA;AAAzB;EAAA;AAAyB;AAIzB;IAAA,mBAA0B;IAA1B,gBAA0B;EAAA;AAA1B;IAAA;MAAA,mBAA0B;IAAA;EAAA;AAA1B;EAAA;AAA0B;AAe1B;EAAA,gBAA6J;EAA7J,oBAA6J;EAA7J,gDAA6J;EAA7J,+BAA6J;EAA7J,kCAA6J;EAA7J,4CAA6J;EAA7J,oCAA6J;EAA7J,6DAA6J;EAA7J,wDAA6J;EAA7J,0BAA6J;EAA7J;AAA6J;AAA7J;EAAA,oBAA6J;EAA7J,gDAA6J;EAA7J;AAA6J;AAM7J;EAAA,oBAAiJ;EAAjJ,gDAAiJ;EAAjJ,+BAAiJ;EAAjJ,kCAAiJ;EAAjJ,4CAAiJ;EAAjJ,oCAAiJ;EAAjJ,6DAAiJ;EAAjJ,wDAAiJ;EAAjJ,0BAAiJ;EAAjJ;AAAiJ;AAAjJ;EAAA,oBAAiJ;EAAjJ,gDAAiJ;EAAjJ;AAAiJ;ACxLjJ;EAAA,aAA+C;EAA/C,qBAA+C;OAA/C;AAA+C;AAA/C;;EAAA;IAAA,qBAA+C;SAA/C;EAA+C;AAAA;AAA/C;;EAAA;IAAA,qBAA+C;SAA/C;EAA+C;AAAA;AAI/C;EAAA,iBAAoF;EAApF;AAAoF;AAApF;;EAAA;IAAA,iBAAoF;IAApF;EAAoF;AAAA;AAApF;;EAAA;IAAA,iBAAoF;IAApF,kBAAoF;IAApF;EAAoF;AAAA;AAApF;;EAAA;IAAA;EAAoF;AAAA;AAApF;;EAAA;IAAA;EAAoF;AAAA;AAApF;EAAA,iBAAoF;EAApF;AAAoF;AAApF;;EAAA;IAAA,iBAAoF;IAApF;EAAoF;AAAA;AAApF;;EAAA;IAAA,iBAAoF;IAApF,kBAAoF;IAApF;EAAoF;AAAA;AAApF;;EAAA;IAAA;EAAoF;AAAA;AAApF;;EAAA;IAAA;EAAoF;AAAA;AAIpF;EAAA,oBACgE;EADhE,mBACgE;EADhE,uBACgE;EADhE,sBACgE;EADhE,gBACgE;EADhE,+BACgE;EADhE,wDACgE;EADhE,0BACgE;EADhE;AACgE;AADhE;EAAA;AACgE;AAIhE;EAAA,kBAAmE;EAAnE,sDAAmE;EAAnE,oBAAmE;EAAnE;AAAmE;AAAnE;EAAA,kBAAmE;EAAnE;AAAmE;AAAnE;EAAA,kBAAmE;EAAnE;AAAmE;AAInE;EAAA,kBAAmE;EAAnE,yDAAmE;EAAnE,oBAAmE;EAAnE;AAAmE;AAAnE;EAAA,kBAAmE;EAAnE;AAAmE;AAAnE;EAAA,kBAAmE;EAAnE;AAAmE;AAInE;EAAA,6BAEuB;EAFvB,oBAEuB;EAFvB,6CAEuB;EAFvB,2GAEuB;EAFvB,yGAEuB;EAFvB,4FAEuB;EAFvB,sBAEuB;EAFvB,6BAEuB;EAFvB;AAEuB;AAFvB;EAAA,sBAEuB;EAFvB,sDAEuB;EAFvB,oBAEuB;EAFvB;AAEuB;AAFvB;EAAA,sBAEuB;EAFvB,yDAEuB;EAFvB,oBAEuB;EAFvB;AAEuB;AAIvB;EAAA,oBAAyG;EAAzG;AAAyG;AAAzG;EAAA,sBAAyG;EAAzG,yDAAyG;EAAzG,oBAAyG;EAAzG;AAAyG;AAAzG;EAAA,sBAAyG;EAAzG,yDAAyG;EAAzG,oBAAyG;EAAzG;AAAyG;AAIzG;EAAA,6BAAwE;EAAxE,oBAAwE;EAAxE;AAAwE;AAAxE;EAAA;AAAwE;AAAxE;EAAA,oBAAwE;EAAxE;AAAwE;AAIxE;EAAA,oBAAyC;EAAzC;AAAyC;AAAzC;EAAA,oBAAyC;EAAzC;AAAyC;AAIzC;EAAA,kBAAiE;EAAjE,wDAAiE;EAAjE,oBAAiE;EAAjE;AAAiE;AAAjE;EAAA,kBAAiE;EAAjE;AAAiE;AAAjE;EAAA,kBAAiE;EAAjE;AAAiE;AAIjE;IAAA,iBAA6B;IAA7B,gBAA6B;IAA7B,kBAA6B;IAA7B,mBAA6B;IAA7B,gBAA6B;IAA7B,mBAA6B;EAAA;AAI7B;IAAA,kBAAwB;IAAxB,gBAAwB;IAAxB,kBAAwB;IAAxB,mBAAwB;IAAxB,gBAAwB;IAAxB,mBAAwB;EAAA;AAIxB;IAAA,eAA0B;IAA1B,gBAA0B;IAA1B,gBAA0B;IAA1B,mBAA0B;IAA1B,kBAA0B;IAA1B,mBAA0B;EAAA;AAI1B;IAAA,mBAAwB;IAAxB,gBAAwB;IAAxB,gBAAwB;IAAxB,mBAAwB;IAAxB,kBAAwB;IAAxB,mBAAwB;EAAA;AAOxB;;;;EAAA,iBAAW;EAAX;AAAW;AAIX;EAAA;AAAe;AAgBf;EAAA;AAAY;AAIZ;EAAA,oBAA+D;EAA/D,mBAA+D;EAA/D,oBAA+D;EAA/D;AAA+D;AAA/D;EAAA,oBAA+D;EAA/D;AAA+D;AAG/D;EAAA,oBAA+D;EAA/D,mBAA+D;EAA/D,oBAA+D;EAA/D;AAA+D;AAA/D;EAAA,oBAA+D;EAA/D;AAA+D;AAGjE;IACE;MACE,wBAAwB;MACxB,oBAAoB;IACtB;IACA;MACE,yBAAyB;MACzB,sBAAsB;IACxB;IACA;MACE,yBAAyB;MACzB,uBAAuB;IACzB;EACF;AAEA;IACE;MACE,yBAAyB;IAC3B;EACF;AAEA;IACE;MACE,UAAU;IACZ;IACA;MACE,UAAU;IACZ;EACF;AAEA;IACE,yCAAyC;EAC3C;AAEA;IACE,oCAAoC;EACtC;AClIF;EAAA,kBAAmB;EAAnB,UAAmB;EAAnB,WAAmB;EAAnB,UAAmB;EAAnB,YAAmB;EAAnB,gBAAmB;EAAnB,sBAAmB;EAAnB,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,WAAmB;EAAnB,YAAmB;EAAnB,UAAmB;EAAnB,SAAmB;EAAnB,iBAAmB;EAAnB,UAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,SAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB,cAAmB;EAAnB,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,WAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;;EAAnB;IAAA;EAAmB;;EAAnB;IAAA;EAAmB;;EAAnB;IAAA;EAAmB;;EAAnB;IAAA;EAAmB;;EAAnB;IAAA;EAAmB;;EAAnB;IAAA;EAAmB;;EAAnB;IAAA;EAAmB;;EAAnB;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,yBAAmB;KAAnB,sBAAmB;UAAnB;AAAmB;AAAnB;EAAA,yBAAmB;KAAnB,sBAAmB;UAAnB;AAAmB;AAAnB;EAAA,wBAAmB;KAAnB,qBAAmB;UAAnB;AAAmB;AAAnB;EAAA,yBAAmB;KAAnB,sBAAmB;UAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,wBAAmB;KAAnB,qBAAmB;UAAnB;AAAmB;AAAnB;EAAA,wBAAmB;KAAnB,qBAAmB;UAAnB;AAAmB;AAAnB;EAAA,8BAAmB;OAAnB;AAAmB;AAAnB;EAAA,+BAAmB;OAAnB;AAAmB;AAAnB;EAAA,6BAAmB;OAAnB;AAAmB;AAAnB;EAAA,+BAAmB;OAAnB;AAAmB;AAAnB;EAAA,8BAAmB;OAAnB;AAAmB;AAAnB;EAAA,8BAAmB;OAAnB;AAAmB;AAAnB;EAAA,+BAAmB;OAAnB;AAAmB;AAAnB;EAAA,gCAAmB;OAAnB;AAAmB;AAAnB;EAAA,8BAAmB;OAAnB;AAAmB;AAAnB;EAAA,+BAAmB;OAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,+BAAmB;OAAnB;AAAmB;AAAnB;EAAA,6BAAmB;OAAnB;AAAmB;AAAnB;EAAA,8BAAmB;OAAnB;AAAmB;AAAnB;EAAA,4BAAmB;OAAnB;AAAmB;AAAnB;EAAA,8BAAmB;OAAnB;AAAmB;AAAnB;EAAA,6BAAmB;OAAnB;AAAmB;AAAnB;EAAA,6BAAmB;OAAnB;AAAmB;AAAnB;EAAA,8BAAmB;OAAnB;AAAmB;AAAnB;EAAA,+BAAmB;OAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;OAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,oDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,2DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,0DAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;UAAnB;AAAmB;AAAnB;EAAA,uBAAmB;UAAnB;AAAmB;AAAnB;EAAA,qBAAmB;UAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,4CAAmB;EAAnB;AAAmB;AAAnB;EAAA,mCAAmB;EAAnB;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,kCAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,mCAAmB;UAAnB;AAAmB;AAAnB;EAAA,mCAAmB;UAAnB;AAAmB;AAAnB;EAAA,mCAAmB;UAAnB;AAAmB;AAAnB;EAAA,mCAAmB;UAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;UAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;KAAnB;AAAmB;AAAnB;EAAA,oBAAmB;KAAnB;AAAmB;AAAnB;EAAA,mBAAmB;KAAnB;AAAmB;AAAnB;EAAA,mBAAmB;KAAnB;AAAmB;AAAnB;EAAA,yBAAmB;KAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kCAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,mCAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qFAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,8FAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,gFAAmB;EAAnB,oGAAmB;EAAnB;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kGAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,yBAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB,+QAAmB;UAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB,+QAAmB;UAAnB;AAAmB;AAAnB;EAAA,kCAAmB;EAAnB,+QAAmB;UAAnB;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB,+QAAmB;UAAnB;AAAmB;AAAnB;EAAA,+QAAmB;UAAnB;AAAmB;AAAnB;EAAA,6BAAmB;UAAnB;AAAmB;AAAnB;EAAA,2KAAmB;EAAnB,mKAAmB;EAAnB,4LAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,gKAAmB;EAAnB,wJAAmB;EAAnB,iLAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,yBAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+FAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AFAnB;EACE,wBAAwB;EACxB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB;;qGAEmG;AACrG;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB;;;;oBAIkB;AACpB;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB;;;;oBAIkB;AACpB;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB;;;;oBAIkB;AACpB;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB;;;;oBAIkB;AACpB;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB;;;;oBAIkB;AACpB;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB;;;;oBAIkB;AACpB;AGhFA;;EFMI;IAAA,iBAAoF;IAApF;EAAoF;;EAApF;;IAAA;MAAA,iBAAoF;MAApF;IAAoF;EAAA;;EAApF;;IAAA;MAAA,iBAAoF;MAApF,kBAAoF;MAApF;IAAoF;EAAA;;EAApF;;IAAA;MAAA;IAAoF;EAAA;;EAApF;;IAAA;MAAA;IAAoF;EAAA;AELxF;AADA;EAAA;AACA;AADA;EAAA;AACA;AADA;EAAA,0BACA;EADA;AACA;AADA;EAAA,0BACA;EADA,WACA;EADA;AACA;AADA;EAAA,0BACA;EADA;AACA;AADA;EAAA,0BACA;EADA,kBACA;EADA;AACA;AADA;EAAA,gBACA;EADA;AACA;AADA;EAAA;AACA;AADA;EAAA,sBACA;EADA;AACA;AADA;EAAA,sBACA;EADA;AACA;AADA;EAAA,sBACA;EADA;AACA;AADA;EAAA,sBACA;EADA;AACA;AADA;EAAA,sBACA;EADA;AACA;AADA;EAAA,sBACA;EADA;AACA;AADA;EAAA,sBACA;EADA;AACA;AADA;EAAA;AACA;AADA;EAAA;AACA;AADA;EAAA,0BACA;EADA;AACA;AADA;EAAA,0BACA;EADA;AACA;AADA;EAAA,sBACA;EADA;AACA;AADA;EAAA,8BACA;EADA;AACA;AADA;EAAA;AACA;AADA;EAAA;AACA;AADA;EAAA,kBACA;EADA;AACA;AADA;EAAA,kBACA;EADA;AACA;AADA;EAAA;AACA;AADA;EAAA;AACA;AADA;EAAA;AACA;AADA;EAAA;AACA;AADA;EAAA;AACA;AADA;EAAA,kBACA;EADA;AACA;AADA;EAAA,sBACA;EADA;AACA;AADA;EAAA,sBACA;EADA;AACA;AADA;EAAA,uBACA;EADA;AACA;AADA;EAAA,uBACA;EADA;AACA;AADA;EAAA,sBACA;EADA;AACA;AADA;EAAA,sBACA;EADA;AACA;AADA;EAAA,sBACA;EADA;AACA;AADA;EAAA,sBACA;EADA;AACA;AADA;EAAA,eACA;EADA,eACA;EADA;AACA;AADA;EAAA,eACA;EADA,eACA;EADA;AACA;AADA;EAAA,sBACA;EADA;AACA;AADA;EAAA,uBACA;EADA;AACA;AADA;EAAA,uBACA;EADA;AACA;AADA;EAAA,uBACA;EADA;AACA;AADA;EAAA,iBACA;EADA,iBACA;EADA;AACA;AADA;;EAAA;IAAA,qBACA;IADA;EACA;;EADA;IAAA,eACA;IADA,eACA;IADA;EACA;;EADA;IAAA,iBACA;IADA,iBACA;IADA;EACA;;EADA;IAAA;EACA;AAAA;AADA;;EAAA;IAAA;EACA;;EADA;IAAA;EACA;;EADA;IAAA;EACA;;EADA;IAAA;EACA;;EADA;IAAA;EACA;;EADA;IAAA;EACA;;EADA;IAAA;EACA;;EADA;IAAA;EACA;;EADA;IAAA;EACA;;EADA;IAAA;EACA;;EADA;IAAA,uBACA;IADA,oDACA;IADA;EACA;;EADA;IAAA,uBACA;IADA,2DACA;IADA;EACA;;EADA;IAAA;EACA;;EADA;IAAA;EACA;;EADA;IAAA;EACA;;EADA;IAAA;EACA;AAAA;AADA;;EAAA;IAAA;EACA;;EADA;IAAA;EACA;;EADA;IAAA;EACA;;EADA;IAAA;EACA;;EADA;IAAA;EACA;;EADA;IAAA;EACA;;EADA;IAAA;EACA;;EADA;IAAA;EACA;;EADA;IAAA;EACA;;EADA;IAAA;EACA;;EADA;IAAA;EACA;;EADA;IAAA;EACA;;EADA;IAAA;EACA;;EADA;IAAA;EACA;;EADA;IAAA;EACA;;EADA;IAAA;EACA;;EADA;IAAA;EACA;;EADA;IAAA;EACA;;EADA;IAAA;EACA;;EADA;IAAA;EACA;;EADA;IAAA;EACA;;EADA;IAAA;EACA;;EADA;IAAA;EACA;;EADA;IAAA;EACA;;EADA;IAAA;EACA;;EADA;IAAA;EACA;AAAA;AADA;;EAAA;IAAA;EACA;;EADA;IAAA;EACA;;EADA;IAAA;EACA;;EADA;IAAA;EACA;;EADA;IAAA;EACA;;EADA;IAAA;EACA;;EADA;IAAA;EACA;;EADA;IAAA;EACA;;EADA;IAAA;EACA;;EADA;IAAA;EACA;;EADA;IAAA;EACA;;EADA;IAAA;EACA;;EADA;IAAA;EACA;AAAA;AADA;;EAAA;IAAA;EACA;;EADA;IAAA;EACA;;EADA;IAAA;EACA;;EADA;IAAA;EACA;;EADA;IAAA;EACA;;EADA;IAAA;EACA;;EADA;IAAA;EACA;;EADA;IAAA;EACA;;EADA;IAAA;EACA;AAAA","sourcesContent":["@tailwind base;\n","@font-face {\n  font-family: \"NativePro\";\n  font-style: normal;\n  font-display: swap;\n  font-weight: 600;\n  src:\n    url(\"https://storage.googleapis.com/ni-assets/assets/fonts/NATIVEPro-600600.woff2\") format(\"woff2\"),\n    url(\"https://storage.googleapis.com/ni-assets/assets/fonts/NATIVEPro-600600.woff\") format(\"woff\");\n}\n\n@font-face {\n  font-family: \"Graphik\";\n  font-style: normal;\n  font-display: swap;\n  font-weight: 400;\n  src:\n    url(\"https://storage.googleapis.com/ni-assets/assets/fonts/Graphik-Regular-Web.woff2\")\n      format(\"woff2\"),\n    url(\"https://storage.googleapis.com/ni-assets/assets/fonts/Graphik-Regular-Web.woff\")\n      format(\"woff\");\n}\n\n@font-face {\n  font-family: \"Graphik\";\n  font-style: italic;\n  font-display: swap;\n  font-weight: 400;\n  src:\n    url(\"https://storage.googleapis.com/ni-assets/assets/fonts/Graphik-RegularItalic-Web.woff2\")\n      format(\"woff2\"),\n    url(\"https://storage.googleapis.com/ni-assets/assets/fonts/Graphik-RegularItalic-Web.woff\")\n      format(\"woff\");\n}\n\n@font-face {\n  font-family: \"Graphik\";\n  font-style: normal;\n  font-display: swap;\n  font-weight: 500;\n  src:\n    url(\"https://storage.googleapis.com/ni-assets/assets/fonts/Graphik-Medium-Web.woff2\")\n      format(\"woff2\"),\n    url(\"https://storage.googleapis.com/ni-assets/assets/fonts/Graphik-Medium-Web.woff\")\n      format(\"woff\");\n}\n\n@font-face {\n  font-family: \"Graphik\";\n  font-style: italic;\n  font-display: swap;\n  font-weight: 500;\n  src:\n    url(\"https://storage.googleapis.com/ni-assets/assets/fonts/Graphik-MediumItalic-Web.woff2\")\n      format(\"woff2\"),\n    url(\"https://storage.googleapis.com/ni-assets/assets/fonts/Graphik-MediumItalic-Web.woff\")\n      format(\"woff\");\n}\n\n@font-face {\n  font-family: \"Graphik\";\n  font-style: normal;\n  font-display: swap;\n  font-weight: 600;\n  src:\n    url(\"https://storage.googleapis.com/ni-assets/assets/fonts/Graphik-Semibold-Web.woff2\")\n      format(\"woff2\"),\n    url(\"https://storage.googleapis.com/ni-assets/assets/fonts/Graphik-Semibold-Web.woff\")\n      format(\"woff\");\n}\n\n@font-face {\n  font-family: \"Graphik\";\n  font-style: italic;\n  font-display: swap;\n  font-weight: 600;\n  src:\n    url(\"https://storage.googleapis.com/ni-assets/assets/fonts/Graphik-SemiboldItalic-Web.woff2\")\n      format(\"woff2\"),\n    url(\"https://storage.googleapis.com/ni-assets/assets/fonts/Graphik-SemiboldItalic-Web.woff\")\n      format(\"woff\");\n}\n\n@layer components {\n  .text-2xs {\n    font-size: 0.64rem;\n    line-height: 1.5;\n  }\n\n  .text-xs {\n    font-size: 0.8rem;\n    line-height: 1.5;\n  }\n\n  .text-sm {\n    font-size: 0.89rem;\n    line-height: 1.5;\n  }\n\n  .text-base {\n    font-size: 1rem;\n    line-height: 1.5;\n  }\n\n  .text-lg {\n    font-size: 1.125rem;\n    line-height: 1.5;\n  }\n\n  .text-xl {\n    font-size: 1.266rem;\n    line-height: 1.3;\n  }\n\n  @media screen(xl) {\n    .text-xl {\n      font-size: 1.563rem;\n    }\n  }\n\n  .text-2xl {\n    font-size: 1.424rem;\n    line-height: 1.3;\n  }\n\n  @media screen(xl) {\n    .text-2xl {\n      font-size: 1.953rem;\n    }\n  }\n\n  .text-3xl {\n    font-size: 1.602rem;\n    line-height: 1.3;\n  }\n\n  @media screen(xl) {\n    .text-3xl {\n      font-size: 2.441rem;\n    }\n  }\n\n  .text-4xl {\n    font-size: 1.802rem;\n    line-height: 1.3;\n  }\n\n  @media screen(xl) {\n    .text-4xl {\n      font-size: 3.052rem;\n    }\n  }\n\n  .webex-h1 {\n    @apply text-4xl font-bold;\n  }\n\n  .webex-h2 {\n    @apply text-3xl font-bold;\n  }\n\n  .webex-h3 {\n    @apply text-2xl font-bold;\n  }\n\n  .webex-h4 {\n    @apply text-xl font-medium;\n  }\n\n  .webex-h5 {\n    @apply text-lg font-medium;\n  }\n\n  .webex-h6 {\n    @apply text-sm font-medium;\n  }\n\n  .webex-link {\n    @apply decoration-transparent font-medium text-grey-90 underline transition-text-decoration duration-150 ease-out hover:decoration-grey-80 hover:text-grey-80;\n  }\n  .theme-dark .webex-link {\n    @apply decoration-transparent font-medium text-grey-10 underline transition-text-decoration duration-150 ease-out hover:decoration-grey-30 hover:text-grey-30;\n  }\n  .webex-link-standalone {\n    @apply decoration-transparent text-grey-90 underline transition-text-decoration duration-150 ease-out hover:decoration-grey-80 hover:text-grey-80;\n  }\n  .theme-dark .webex-link-standalone {\n    @apply decoration-transparent text-grey-10 underline transition-text-decoration duration-150 ease-out hover:decoration-grey-30 hover:text-grey-30;\n  }\n\n  .webex-paragraph {\n    @apply text-base;\n  }\n\n  .webex-paragraph-lg {\n    @apply text-lg;\n  }\n\n  .webex-paragraph-xl {\n    @apply text-xl;\n  }\n\n  .webex-paragraph-sm {\n    @apply text-sm;\n  }\n\n  .webex-eyebrow {\n    @apply text-grey-50 text-sm font-medium;\n  }\n\n  .webex-list-disc {\n    @apply list-disc pl-3 marker:text-sm;\n  }\n\n  .webex-list-arrow {\n    @apply list-image-arrow pl-3;\n  }\n\n  .webex-list-arrow li {\n    @apply list-outside ml-0.75 pl-1.25 pb-1;\n  }\n}\n","@layer components {\n  .webex-grid {\n    @apply grid gap-x-[25px] md:gap-x-6 2xl:gap-x-8;\n  }\n\n  .container {\n    @apply mx-3 md:mx-5 lg:mx-auto lg:max-w-[912px] xl:max-w-[1104px] 2xl:max-w-[1472px];\n  }\n\n  .webex-btn {\n    @apply inline-flex items-center justify-center rounded font-medium\n    transition-bg duration-150 ease-out disabled:pointer-events-none;\n  }\n\n  .webex-btn--primary {\n    @apply text-grey-10 disabled:bg-grey-60 bg-grey-90 hover:bg-grey-80;\n  }\n\n  .theme-dark .webex-btn--primary {\n    @apply bg-grey-10 text-grey-90 hover:bg-grey-20 disabled:bg-grey-40;\n  }\n\n  .webex-btn--secondary {\n    @apply bg-transparent ring-2 ring-inset ring-current ring-offset-0\n    text-grey-90 hover:text-grey-80 hover:border-grey-80 disabled:text-grey-60\n    disabled:border-grey-60;\n  }\n\n  .theme-dark .webex-btn--secondary {\n    @apply text-grey-10 hover:text-grey-20 hover:border-grey-20 disabled:text-grey-40 disabled:border-grey-40;\n  }\n\n  .webex-btn--ghost {\n    @apply bg-transparent text-grey-90 hover:underline disabled:text-grey-60;\n  }\n\n  .theme-dark .webex-btn--ghost {\n    @apply text-grey-10 disabled:text-grey-40;\n  }\n\n  .webex-btn--highlight {\n    @apply text-white disabled:bg-grey-50 bg-blue-50 hover:bg-blue-60;\n  }\n\n  .webex-btn--xs {\n    @apply text-xs px-1.5 py-0.75;\n  }\n\n  .webex-btn--sm {\n    @apply text-sm px-2 py-1;\n  }\n\n  .webex-btn--regular {\n    @apply text-base py-1 px-3;\n  }\n\n  .webex-btn--lg {\n    @apply text-lg py-1 px-3;\n  }\n\n  .webex-btn--xs.webex-btn--ghost,\n  .webex-btn--sm.webex-btn--ghost,\n  .webex-btn--regular.webex-btn--ghost,\n  .webex-btn--lg.webex-btn--ghost {\n    @apply px-0;\n  }\n\n  .webex-btn--loading {\n    @apply relative;\n  }\n\n  .webex-text-field {\n    @apply border-grey-30 rounded-lg border px-2 py-1;\n  }\n\n  .webex-text-field--invalid {\n    @apply border-[red];\n  }\n\n  .webex-text-field--disabled {\n    @apply opacity-60;\n  }\n\n  .webex-checkbox:checked ~ .webex-checkmark {\n    @apply block;\n  }\n\n  .webex-media-btn {\n    @apply inline-flex items-center text-grey-90 hover:text-grey-80;\n  }\n  .theme-dark .webex-media-btn {\n    @apply inline-flex items-center text-grey-10 hover:text-grey-20;\n  }\n\n  @keyframes dash {\n    0% {\n      stroke-dasharray: 1, 150;\n      stroke-dashoffset: 0;\n    }\n    50% {\n      stroke-dasharray: 90, 150;\n      stroke-dashoffset: -35;\n    }\n    100% {\n      stroke-dasharray: 90, 150;\n      stroke-dashoffset: -124;\n    }\n  }\n\n  @keyframes spin {\n    100% {\n      transform: rotate(360deg);\n    }\n  }\n\n  @keyframes fadein {\n    from {\n      opacity: 0;\n    }\n    to {\n      opacity: 1;\n    }\n  }\n\n  .webex-animation-dash {\n    animation: dash 1.5s ease-in-out infinite;\n  }\n\n  .webex-animation-spin {\n    animation: spin 1.5s linear infinite;\n  }\n}\n","@tailwind utilities;\n","@import '@native-instruments/webex-ni/dist/css/index.css';\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
